window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  const selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    dynamicCheckoutButton: '.dynamic-checkout-button',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productImage: '[data-product-image]',
    productImageId: '[data-product-image-id]',
    productSlideshow: '[data-product-slideshow]',
    productJson: '[data-product-json]',
    productKlaviyoJson: '[data-product-klaviyo-json]',
    productPrice: '[data-product-price]',
    productPriceMobile: '[data-product-price-mobile]',
    productPriceSeparator: '[data-product-price-mobile-separator]',
    singleOptionSelector: '[data-single-option-selector]',
    includesOptionSelector: '[data-includes-option-selector]',
    addToCartWrapper: '.product-quantity-button',
    klaviyoBisContainer: '.product-form-klaviyo-bis',
    smartrrForm: '.smartrr-purchase-options',
    smartrrSubscriptionOption: '[data-smartrr-selling-plan-group-id]:not(.smartrr-otp)'
  };
  var players = [];
  var isYoutubeAPIReady = false || window.isYoutubeAPILoaded;
  var defaultYoutubeOptions = {
    height: '720',
    width: '1280',
    playerVars: {
      cc_load_policy: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      autohide: 0,
      controls: 1,
      branding: 0,
      loop: 0,
      rel: 0,
      fs: 0,
      wmode: 'opaque',
      origin: 'https:'
    },
    events: { }
  };
  
  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    var $container = this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.changeOptionShadeColor(this);
    this.changeOption(this);
    this.addToCartWrapperFixed();

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.productKlaviyoObject = JSON.parse($(selectors.productKlaviyoJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$productdImages = $(selectors.productImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.smartrrVariantChange.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateVariantSku.bind(this));
    this.$container.on('variantChange' + this.namespace, this.onIncludesToggle.bind(this));
    
    this.$container.on('variantChange' + this.namespace, this.tryOnVariantChange.bind(this));
    this.$container.on('click', '[data-ymk-button]', this.YMK_Open.bind(this));
    this.$container.on('change', selectors.includesOptionSelector, this.onIncludesOptionChange.bind(this));
  
    if(!window.YMK) {
      window.ymkAsyncInit = this.tryOnInit.bind(this);
    } else {
      this.currentYMKSku - this.variants.currentVariant.sku;
      this.tryOnInit.call(this);
    }
    
    if (this.$productdImages.length > 0) {
      this.$container.on('variantChange', this.updateProductImage.bind(this));
    }
    this.clickAddToCart();
    this.klaviyoBIS();
    this.initVideoPlayers();
    this.pauseActiveVideo($container);
    this.smartrrSubscriptionForm();
    this._onHideSubscriptionForm(this.variants.currentVariant);
  }

  Product.prototype = $.extend({}, Product.prototype, theme.Cart.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      const variant = evt.variant;
      const $dynamicCheckoutButton = $(selectors.dynamicCheckoutButton);
      const $preorderMessage = $('.product-preorder-item');
      const $variantPreorderMessage = $('.product-preorder-item--' + variant.id);
      const $klaviyoBisContainer = $(selectors.klaviyoBisContainer);

      if ($klaviyoBisContainer.length) {
        $klaviyoBisContainer.slideUp();
        $klaviyoBisContainer.find('.product-form-klaviyo-bis__email-invalid').slideUp();
        $klaviyoBisContainer.find('.product-form-klaviyo-bis__klaviyo-error').slideUp();
        $klaviyoBisContainer.find('.product-form-klaviyo-bis__subscription').slideUp();
      }
      if (variant) {
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true).addClass('btn--alert');
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        return;
      }
      
      if (variant.available && variant.inventory_quantity < 1 && $variantPreorderMessage.length) {
        if ($preorderMessage.is(':visible')) {
          $preorderMessage.slideUp(400, function () {
            $variantPreorderMessage.slideDown();
          })
        } else {
          $variantPreorderMessage.slideDown();
        }
        $(selectors.addToCart, this.$container).prop('disabled', false).removeClass('btn--alert').removeClass('product-klaviyo-bis-trigger').attr('data-varaint-preorder-value', 'true');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCartPreOrder);
  
        if($dynamicCheckoutButton.length > 0) {
          $dynamicCheckoutButton.removeClass('disabled');
          $dynamicCheckoutButton.slideDown();
        }
      } else if (variant.available && variant.inventory_quantity > 1) {
        $preorderMessage.slideUp();
        $(selectors.addToCart, this.$container).prop('disabled', false).removeClass('btn--alert').removeClass('product-klaviyo-bis-trigger').attr('data-varaint-preorder-value', 'false');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        
        if($dynamicCheckoutButton.length > 0) {
          $dynamicCheckoutButton.removeClass('disabled');
          $dynamicCheckoutButton.slideDown();
        }
      } else if (!$klaviyoBisContainer.length) {
        $preorderMessage.slideUp();
        $(selectors.addToCart, this.$container).prop('disabled', true).addClass('btn--alert').attr('data-varaint-preorder-value', 'false');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
  
        if($dynamicCheckoutButton.length > 0) {
          $dynamicCheckoutButton.addClass('disabled');
          $dynamicCheckoutButton.slideDown();
        }
      } else {
        $preorderMessage.slideUp();
        $(selectors.addToCart, this.$container).prop('disabled', false).addClass('product-klaviyo-bis-trigger').attr('data-varaint-preorder-value', 'false');
        $(selectors.addToCartText, this.$container).html(theme.strings.joinTheWaitlist);
  
        if($dynamicCheckoutButton.length > 0) {
          $dynamicCheckoutButton.addClass('disabled');
          $dynamicCheckoutButton.slideUp();
        }
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      const variant = evt.variant;
      const $comparePrice = $(selectors.comparePrice, this.$container);
      const $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      const $variantPreorderMessage = $('.product-preorder-item--' + variant.id);

      if (variant.available && variant.inventory_quantity < 1 && $variantPreorderMessage.length) {
        $(selectors.productPrice, this.$container)
          .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        $(selectors.productPriceMobile, this.$container)
          .show()
          .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        $(selectors.productPriceSeparator, this.$container)
          .show();
        
        //Hide subscription form and select One Time option
        $(selectors.smartrrForm).slideUp();
        $('.smartrr-otp .smartrr-selling-plan-group-label').click();

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.show();
        } else {
          $comparePrice.html('');
          $compareEls.hide();
        }
      } else if (variant.available && variant.inventory_quantity > 1) {
  
        if (typeof smartrrProductList == 'object' && variant.selling_plan_allocations.length) {
          const getSmarterSettings = smartrrProductList[Object.keys(smartrrProductList)[0]];  //From {1234: {...data}} To {...data}
          const isOTP = getSmarterSettings.logic.current.planId === '';
          const sellingPrice = variant.selling_plan_allocations[0].per_delivery_price;
          const sellingComparedPrice = variant.selling_plan_allocations[0].compare_at_price;
    
          if(!isOTP) {
            $(selectors.productPrice, this.$container)
                .html(`${slate.Currency.formatMoney(sellingPrice, theme.moneyFormat)}`);
            $(selectors.comparePrice, this.$container)
                .html(`${slate.Currency.formatMoney(sellingComparedPrice, theme.moneyFormat)}`)
      
            $(selectors.productPriceMobile, this.$container)
                .html(slate.Currency.formatMoney(sellingPrice, theme.moneyFormat));
      
            this._onHideSubscriptionForm(variant);
          } else {
            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
            $(selectors.productPriceMobile, this.$container)
                .show()
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
            $(selectors.productPriceSeparator, this.$container)
                .show();
  
            this._onHideSubscriptionForm(variant);
          }
        } else {
          $(selectors.productPrice, this.$container)
              .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
          $(selectors.productPriceMobile, this.$container)
              .show()
              .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
          $(selectors.productPriceSeparator, this.$container)
              .show();
          
          this._onHideSubscriptionForm(variant);
        }

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.show();
        } else {
          $comparePrice.html('');
          $compareEls.hide();
        }
      } else {
        $(selectors.productPrice, this.$container).html(theme.strings.soldOut);
        $(selectors.productPriceMobile, this.$container).hide();
        $(selectors.productPriceSeparator, this.$container).hide();
        $comparePrice.html('');
        $compareEls.hide();
  
        this._onHideSubscriptionForm(variant);
      }
    },

    updateVariantSku: function (evt) {
      const variant = evt.variant;
      const currentVariantSku = $('[data-current-variant-sku]');
      const variantSku = variant.sku;

      if (!currentVariantSku) {
        return
      }

      if (variantSku === '' || !variantSku) {
        currentVariantSku.parent().hide();
      } else {
        currentVariantSku.parent().show();
        currentVariantSku.text(variantSku);
      }
    },

    changeOptionShadeColor: function(context) {
      var $container = context.$container;

      $('.product-options-select__button', $container).on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle();

        var isHidden = $(this).next().attr('aria-hidden') === 'true';
        $(this).next().attr('aria-hidden', !isHidden);
      });

      $(document).on('keydown', '.product-options-select__list', function (e) {
        var $focusable =$(this).find('.product-options-select__item').not('.selected').find('button');
        var first = $focusable.first()[0];
        var last = $focusable.last()[0];

        if (e.key === 'Escape' || e.keyCode === 27) {
          e.preventDefault();
          $(this).slideUp().attr('aria-hidden', 'true');
          $(this).parent().removeClass('active');
          $(this).siblings('.product-options-select__button').focus();
          return;
        }

        if (e.key === 'Tab') {
          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      });

      $(document).mouseup(function (e){
        var div = $('.product-options-select .product-options-select__list');
        var parentDiv = $('.product-options-select .product-options-select__button');
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {

          $('.product-options-select .product-options-select__inner').removeClass('active');
          $('.product-options-select .product-options-select__list').slideUp().attr('aria-hidden', 'true');
        }
      });

      $('.product-options-select__item', $container).on('click', function () {
        var value = $(this).attr('data-value');
        var $parent = $(this).parents('.product-options-select');
        var $input = $parent.prev().find(selectors.singleOptionSelector + '[value="'+ value +'"]');
        var $inputOthers = $parent.prev().find(selectors.singleOptionSelector + ':not([value="'+ value +'"])').prop('checked', false);
        var $labelText = $parent.find('.product-options-select__label>div:first-child');
        var $content = $(this).html();

        $parent.find('.product-options-select__inner').removeClass('active');
        $parent.find('.product-options-select__list').slideUp();
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');

        $labelText.html($content);
        $inputOthers.prop('checked', false);
        $input.prop('checked', true);
        $input.trigger('change');
      });

      $('.product-options-swatch__btn', $container).on('click', function (e) {
        e.preventDefault();
        var $wrapper = $(this).parents('.product-options-swatch__wrapper');
        var $fieldset = $wrapper.find('.product-options-swatch-fieldset');

        $wrapper.toggleClass('collapse');

        if ($wrapper.hasClass('collapse')) {
          $(this).find('span:first-child').hide();
          $(this).find('span:nth-child(2)').fadeIn();
          $fieldset.find('.product-options-swatch__group-label').show().animate({width: "100%"}, 300, function () {
            $fieldset.find('.product-options-swatch__group-label').show()
          });
        } else {
          $(this).find('span:nth-child(2)').hide();
          $(this).find('span:first-child').fadeIn();
          $fieldset.find('.product-options-swatch__group-label').animate({width: "0%"}, 300, function () {
            $fieldset.find('.product-options-swatch__group-label').hide()
          });
        }
      });

      $(document).on('click', '.product-options-swatch__input' + selectors.singleOptionSelector, function () {
        $('.product-options-select__item[data-value="' + $(this).val() + '"]:not(.selected)').trigger('click');
      });
    },

    changeOption: function(context) {
      var $container = context.$container;

      $('.product-options__button', $container).on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle();
      });

      $(document).mouseup(function (e){
        var div = $('.product-options .product-options__list');
        var parentDiv = $('.product-options .product-options__button');
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {

          $('.product-options .product-options__inner').removeClass('active');
          $('.product-options .product-options__list').slideUp();
        }
      });

      $('.product-options__item', $container).on('click', function () {
        var value = $(this).attr('data-value');
        var $parent = $(this).parents('.product-options');
        var $input = $parent.find(selectors.singleOptionSelector);
        var $spanForValue = $parent.find('.product-options__value');

        $parent.find('.product-options__inner').removeClass('active');
        $parent.find('.product-options__list').slideUp();
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');

        $spanForValue.html(value);
        $input.val(value).trigger('change');
      });
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      const variant = evt.variant;
      const $slideshow = $(`[data-product-slideshow]`, this.$container);
      const $thumbnails = $(`[data-product-thumbnails-slideshow]`, this.$container);
  
      if (!variant) {
        return;
      }

      $slideshow.slick('slickUnfilter');
      $thumbnails.slick('slickUnfilter');
      
      const variantFilteredSlides = $(`.product__slide[data-variant-filter=${variant.id}]`, this.$container);

      if (variantFilteredSlides.length) {
        $slideshow.slick('slickFilter', $(`.product__slide[data-variant-filter=${variant.id}], .product__slide:not([data-variant-filter])`, this.$container));
        $thumbnails.slick('slickFilter', $(`.product__thumbnail[data-variant-filter=${variant.id}], .product__thumbnail:not([data-variant-filter])`, this.$container));
  
        $thumbnails.slick('getSlick').$slides.each(function(index, element) { $(element).attr('data-slick-index', index); });
        $slideshow.slick('getSlick').$slides.each(function(index, element) { $(element).attr('data-slick-index', index); });
  
        $slideshow.slick('getSlick').currentSlide = 0;
        $slideshow.slick('slickGoTo', 0, false).slick('refresh');
        $slideshow.slick('getSlick').updateDots();
      } else {
        $slideshow.slick('slickFilter', $(`.product__slide:not([data-variant-filter])`, this.$container));
        $thumbnails.slick('slickFilter', $(`.product__thumbnail:not([data-variant-filter])`, this.$container));
  
        $thumbnails.slick('getSlick').$slides.each(function(index, element) { $(element).attr('data-slick-index', index); });
        $slideshow.slick('getSlick').$slides.each(function(index, element) { $(element).attr('data-slick-index', index); });

        if (variant.featured_media) {
          const imageId = variant.featured_media.id;
          const slideIndex = parseInt($('[data-product-image-id="'+imageId+'"]', this.$container).parents('.slick-slide').attr('data-slick-index'));
          const productId = this.productSingleObject.id;
  
          $slideshow.slick('getSlick').currentSlide = slideIndex;
          $('[data-product-slideshow="'+ productId +'"]').slick('slickGoTo', slideIndex, false).slick('refresh');
          $slideshow.slick('getSlick').updateDots();
        }
      }
    },

    clickAddToCart: function () {
      var _self = this;

      theme.quantitySelectors();

      $(document).on('click', '[data-add-to-cart]:not(.product-klaviyo-bis-trigger)', function (evt){
        evt.preventDefault();
        var form = $(this).closest('form');
        var form_array = form.serializeArray();

        if (form.find('[type="file"]').length){
          return;
        }

        $(this).prop('disabled', true);

        var form_data = {};

        $.map(form_array, function(val) {
          form_data[val.name] = val.value;
        });

        if ($(this).attr('data-varaint-preorder-value') == 'true' && $('.product-preorder-item--' + form_data.id).length) {
          if (form_data.properties) {
            form_data.properties['Preorder'] = $('.product-preorder-item--' + form_data.id).find('span').text();
          } else {
            form_data.properties = {'Preorder': $('.product-preorder-item--' + form_data.id).find('span').text()};
          }
        }

        _self.ajaxAddToCart(form_data);
      })
    },

    ajaxAddToCart: function (data) {
      var _self = this;
      var $container = $(this.container);
      var errorContainer = $container.find('.product-form-error');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data
      }).done(function () {
        $(document).trigger('product:added');
        
        $('[data-add-to-cart]').prop('disabled', false);
        if (errorContainer.length) {
          errorContainer.slideUp();
        }

        var _learnq = window._learnq || [];
        _learnq.push(['track', 'Added to Cart', _self.productKlaviyoObject]);

      }).fail(function (error) {
        if (error.status === 422 && errorContainer.length) {
          errorContainer.text(error.responseJSON.description);
          errorContainer.slideDown();
        }
        console.log(error);
        $('[data-add-to-cart]').prop('disabled', false);
      })
    },

    addToCartWrapperFixed: function () {
      var _self = this;

      if (this.$container.hasClass('bundle-product-item')) {return false}

      $(window).on('scroll orientationchange', $.throttle(300, function () {
        var $productForm = $('.product__form', _self.$container);
        var productFormTop = $productForm.offset().top;
        var productHeight = $productForm.outerHeight();
        var productFormBottom = parseInt(productFormTop, 10) +  parseInt(productHeight, 10);
        var addToCartWrapperHeight = $(selectors.addToCartWrapper).height();
        var $adaWrapper = $('div.accessibility-wrap');

        if ($(window).width() < 768) {
          if ($(window).scrollTop() > productFormBottom) {
            $(selectors.addToCartWrapper).parent().outerHeight(addToCartWrapperHeight);
            $(selectors.addToCartWrapper).fadeIn('300').addClass('is-fixed');
            if ($adaWrapper.length) {
              $adaWrapper.animate({bottom: "140px"}, 100);
            }
          } else if ($(window).scrollTop() <= productFormBottom) {
            $(selectors.addToCartWrapper).css('display', '').parent().css('height', 'auto');
            $(selectors.addToCartWrapper).removeClass('is-fixed');
            if ($adaWrapper.length) {
              $adaWrapper.animate({bottom: "15px"}, 100);
            }
          }
        }
      }));
    },

    klaviyoBIS: function () {
      $(document).on('click', '.product-klaviyo-bis-trigger', function (evt) {
        evt.preventDefault();

        $(this).parents('form').find('.product-form-klaviyo-bis').slideToggle();
      });

      $('.product-form-klaviyo-bis').find('button').on('click', function (evt) {
        evt.preventDefault();

        function validateEmail(email) {
          var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }

        var $bisContainer = $(this).parents('.product-form-klaviyo-bis');
        var productId = $bisContainer.attr('data-bis-product-id');
        var variantId = $(selectors.originalSelectorId)[0].value;
        var email = $bisContainer.find('[name="email"]').val();
        var origin = '';
        var data = {
          'a': 'Jsnu2D',
          'email': email,
          '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
          'variant': variantId,
          'product': productId,
          'platform': 'shopify'
        };

        var $emailInvalid = $bisContainer.find('.product-form-klaviyo-bis__email-invalid');
        var $klaviyoError = $bisContainer.find('.product-form-klaviyo-bis__klaviyo-error');
        var $subscription = $bisContainer.find('.product-form-klaviyo-bis__subscription');

        $emailInvalid.slideUp();
        $klaviyoError.slideUp();
        $subscription.slideUp();

        if (!validateEmail(email)) {
          $emailInvalid.slideDown();
          return
        }

        $.ajax({
          method: 'POST',
          url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
          data: data
        }).done(function (response) {
          if (response.success) {
            $subscription.slideDown();
          } else {
            console.error('Error Klaviyo: ', response.errors);
            $klaviyoError.slideDown();
          }
        }).fail(function (err) {
          $klaviyoError.slideDown();
        });
      });
    },

    initVideoPlayers: function () {
      var youtubeIsPresent = this.$container.find('[data-video-host="youtube"]')
      var vimeoIsPresent = this.$container.find('[data-video-host="vimeo"]')

      if (youtubeIsPresent.length) {
        if (isYoutubeAPIReady) {
          this.loadYoutubePlayer();
        } else {
          // Load Youtube API if not loaded yet
          window.loadYoutubeAPI();
          $('body').on('youtubeAPIReady', this.loadYoutubePlayer.bind(this));
        }
      }
      if (vimeoIsPresent.length) {
        this.loadVimeoPlayer()
      }
    },

    loadYoutubePlayer: function () {
      var currentYoutubeOptions = $.extend({}, defaultYoutubeOptions);
      $.each($('[data-video-host="youtube"]'), function (index, elem) {
        var $elem = $(elem);
        var thisVideoId = $elem.attr('data-video-id');

        currentYoutubeOptions.videoId = thisVideoId;

        if (thisVideoId) {
          players[thisVideoId] = new YT.Player(thisVideoId, currentYoutubeOptions);
        }
      });

      isYoutubeAPIReady = true;
    },

    loadVimeoPlayer: function () {
      $.each($('[data-video-host="vimeo"]'), function (index, elem) {
        var $elem = $(elem);
        var $iframe = $elem.find('iframe');
        var thisVideoId = $elem.attr('data-video-id');

        if (thisVideoId) {
          players[thisVideoId] = new Vimeo.Player($iframe, {});
        }
      })
    },

    pauseActiveVideo: function () {

      $('.product__images').on('beforeChange', function (event, slick, currentSlide) {
        var elt = slick.$slides.get(currentSlide);
        var $elt = $(elt);
        var mediaType = $elt.find('[data-media-type]').attr('data-media-type');

        if (mediaType == 'youtube') {
          var playerId = $elt.find('[data-video-id]').attr('data-video-id');

          players[playerId].pauseVideo();

        } else if (mediaType == 'vimeo') {
          var playerId = $elt.find('[data-video-id]').attr('data-video-id');

          players[playerId].pause();

        } else if (mediaType == 'video') {

          $elt.find('video').get(0).pause();
        }
      })
    },
    
    smartrrSubscriptionForm: function() {
      const $productPrice = $(selectors.productPrice);
      const $productComparePrice = $(selectors.comparePrice);
      const $productPriceMobile = $(selectors.productPriceMobile);
      const currentVariant = this.variants.currentVariant;
  
      $('[data-smartrr-selling-plan-group-input]').on('change', onSubscriptionChange);
      
      function onSubscriptionChange() {
        const getSmarterSettings = smartrrProductList[Object.keys(smartrrProductList)[0]];  //From {1234: {...data}} To {...data}
        const isOTP = getSmarterSettings.logic?.current?.planId === '';
        const variantOptions = $(".no-js");
    
        //Plan Container Active class
        $('[data-smartrr-selling-plan-group-id]').removeClass("active-plan");
        $(this).parents('[data-smartrr-selling-plan-group-id]').addClass('active-plan');
    
        //???
        $(this).parents("div[data-smartrr-selling-plan-group-id]").find(".selling-plan-list li").eq(0).trigger("click");
        
        //Price Change
        if(!isOTP) {
          const discountPrice = `${variantOptions.find('option:selected').attr('data-subscription-price')}`;
  
          if(discountPrice < currentVariant.price) {
            $productPrice.html(`${slate.Currency.formatMoney(discountPrice, theme.moneyFormat)}`);
            $productComparePrice.html(`${slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat)}`);
            $productComparePrice.show();
            $productPriceMobile.html(`${slate.Currency.formatMoney(discountPrice, theme.moneyFormat)}`);
          } else {
            $productPrice.html(`${slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat)}`);
            $productComparePrice.html(``);
            $productComparePrice.hide();
            $productPriceMobile.html(`${slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat)}`);
          }
        } else {
          if(currentVariant.compare_at_price > currentVariant.price) {
            $productPrice.html(slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat));
            $productComparePrice.html(`${slate.Currency.formatMoney(currentVariant.compare_at_price, theme.moneyFormat)}`);
            $productComparePrice.show();
            $productPriceMobile.html(slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat));
          } else {
            $productPrice.html(slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat));
            $productComparePrice.html(``);
            $productComparePrice.hide();
            $productPriceMobile.html(slate.Currency.formatMoney(currentVariant.price, theme.moneyFormat));
          }
        }
    
        console.dir('Smartrr: plan changed');
      }
  
      //Select subscription by default
      // $('input[name="purchase_option"]').eq(1).trigger("click");
      
      $('.selected-country').click(function() {
        $('#store-multi-currency-overlay').fadeIn(300);
      });
  
      $('#store-multi-currency-close').click(function() {
        $('#store-multi-currency-overlay').fadeOut(300);
      });
  
      $(".all-countries-list li").click(function(){
        const countryName = $(this).attr("data-country-name");
    
        $("#localization_form .country_code").val(countryName);
        $("#localization_form").submit();
      });
    },
    
    smartrrVariantChange: function(e) {
      const variant = e.variant;
      
      if(!variant)  return;
      
      if (variant.selling_plan_allocations.length && window.smartrrProductList) {
        const smartrr = window.smartrrProductList;
        const smartrrId = Object.keys(smartrr)[0];
  
        smartrr[smartrrId].ui.logic.apiChangeVariant(variant.id);
        
        $(selectors.smartrrForm).slideDown();
      } else if (!variant.selling_plan_allocations.length) {
        $(selectors.smartrrForm).slideUp();
      }
    },
    
    _onHideSubscriptionForm: function(variant) {
      if(!variant)  return;
      
      if (variant.inventory_quantity > window.theme.subscriptionThreshold && variant.selling_plan_allocations.length) {
        $(selectors.smartrrSubscriptionOption).slideDown();
      } else {
        $(selectors.smartrrSubscriptionOption).slideUp();
  
        $('.smartrr-otp .smartrr-selling-plan-group-label input[type="radio"]').trigger('click');
      }
    },
    
    tryOnInit: function() {
      const buttons = $('.YMK-button', this.$container);
  
      //Enable button
      if(buttons.length) {
        buttons.removeAttr('disabled');
      }
  
      window.YMK.init({showCloseBtnOnLauncher: true});
  
      YMK.addEventListener('loaded', () => {
        YMK.applyMakeupBySku(this.currentYMKSku);
      });
  
      YMK.addEventListener('closed', () => {
        console.log('YMK closed');
        this.$container.removeClass('ymk-opened');
      });
  
      YMK.addEventListener('opened', () => {
        console.log('YMK opened');
    
        setTimeout(() => {
          this.tryOnChangeWidgetSize();
        }, 1000);
    
        this.$container.addClass('ymk-opened');
      });
      
      YMK.addEventListener('compare', () => {
        $('[data-ymk-compare]', this.$container).show();
      });
      
      YMK.addEventListener('compareDisabled', () => {
        $('[data-ymk-compare]', this.$container).hide();
      });
  
      $(window).on('orientationchange resize', $.throttle(300, () => {
        this.tryOnChangeWidgetSize();
      }));
  
      console.log('YMK: INITIALIZED');
    },
    
    onIncludesToggle: function(e) {
      const includesOptions = $(`[data-includes-variant=${e.variant.id}]`, this.$container);
      
      if (includesOptions.length) {
        $(`#ProductIncludesOptionsWrapper-${this.id}`, this.$container).show();
        
        $(`[data-includes-variant]`).hide();
        includesOptions.show();
      } else {
        $(`#ProductIncludesOptionsWrapper-${this.id}`, this.$container).hide();
      }
    },
  
    onIncludesOptionChange: function(e) {
      const target = $(e.target);
      const sku = target.val();
      const variant = this.variants.currentVariant;
      const prevVariant = $('[data-ymk-prev-variant]', this.$container);
      const currentVariant = $('[data-ymk-current-variant]', this.$container);
      const checkedSwatch = $('[data-includes-option-selector]:checked:visible', this.$container).parent();
      const includesOptions = $(`[data-includes-variant=${variant.id}]`, this.$container);
      const currentTitle = target.attr('aria-label') !== '' ? target.attr('aria-label') : variant.title;
      
      if (!window.YMK)  return;
  
      $('[data-includes-name]').text(target.attr('aria-label'));
      this.currentYMKSku = sku;
      YMK.applyMakeupBySku(sku);
  
      if (!this.$container.hasClass('ymk-opened')) {
        $('.YMK-button', this.$container).addClass('YMK-button__highlight');
        $('.YMK-button', this.$container).focus();
        
        $('.YMK-button', this.$container).on('animationend', function() {
          $(this).removeClass('YMK-button__highlight');
        })
      }
      
      //Change current variant
      $('.product-options-swatch__image', currentVariant)
          .attr('style', $('.product-options-swatch__image ', checkedSwatch).attr('style'));
      $('.YMK-module__heading', currentVariant).text(currentTitle);

      //Change prev variant
      $('.product-options-swatch__image', prevVariant)
          .attr('style', prevVariant.attr('data-styles'));
      $('.YMK-module__heading', prevVariant).text(prevVariant.attr('data-title'));

      //Set old values to prev variant
      $(prevVariant).attr('data-styles', $('.product-options-swatch__image ', checkedSwatch).attr('style'));
      $(prevVariant).attr('data-title', currentTitle);
    },
    
    tryOnVariantChange: function(e) {
      const variant = e.variant;
      const prevVariant = $('[data-ymk-prev-variant]', this.$container);
      const currentVariant = $('[data-ymk-current-variant]', this.$container);
      const checkedOption = $(`[data-includes-variant=${variant.id}] input:checked`, this.$container);
      const variantTitle = checkedOption.attr('aria-label') !== '' ? checkedOption.attr('aria-label') : variant.title;
  
      if(!window.YMK) return;
  
      //Change current variant
      $('.product-options-swatch__image', currentVariant)
          .attr('style', $('.product-options-swatch__image ', checkedOption.parent()).attr('style'));
      $('.YMK-module__heading', currentVariant).text(variantTitle);
  
      //Change prev variant
      $('.product-options-swatch__image', prevVariant).attr('style', prevVariant.attr('data-styles'));
      $('.YMK-module__heading', prevVariant).text(prevVariant.attr('data-title'));
      
      //Set old values to prev variant
      $(prevVariant).attr('data-styles', $('.product-options-swatch__image ', checkedOption.parent()).attr('style'));
      $(prevVariant).attr('data-title', variantTitle);
      
      if (checkedOption.length) {
        this.currentYMKSku = checkedOption.val();
        $('[data-includes-name]').text(checkedOption.attr('aria-label'));
        
        YMK.applyMakeupBySku(checkedOption.val());
      } else {
        this.currentYMKSku = variant.sku;
        
        YMK.applyMakeupBySku(variant.sku);
      }
    },
  
    YMK_Open: function() {
      const includesOptions = $(`[data-includes-variant=${this.variants.currentVariant.id}]`, this.$container);
      
      if(!window.YMK) return;
  
      this.$container.addClass('ymk-opened');
  
      if (includesOptions.length) {
        const firstOption = includesOptions.first().find('input');
  
        this.currentYMKSku = firstOption.val();
        window.YMK.applyMakeupBySku(firstOption.val());
      } else {
        this.currentYMKSku = this.variants.currentVariant.sku;
        window.YMK.applyMakeupBySku(this.variants.currentVariant.sku);
      }
  
      window.YMK.open();
  
      this.tryOnChangeWidgetSize();
    },
    
    tryOnChangeWidgetSize: function() {
      if(!window.YMK) return;
      
      const imageContainerWidth = $('.product__images-container', this.$container).outerWidth(false);
      const limitWidth = imageContainerWidth >= 600 ? 600 : imageContainerWidth;
  
      const isMobile = limitWidth.width <= 414;
      const width = isMobile ? limitWidth.width - 44 : limitWidth;
      const height = isMobile ? parseInt((limitWidth.width - 44) * 1.2) : (4 / 3) * width;
      
      window.YMK.changeSize({
        width: width,
        height: height
      });
    },
    
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

  });

  return Product;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.ProductBundleItem = (function() {

  var selectors = {
    originalSelectorId: '[data-product-select]',
    productFeaturedImage: '[data-product-featured-image]',
    productImage: '[data-product-image]',
    productImageId: '[data-product-image-id]',
    productSlideshow: '[data-product-slideshow]',
    productJson: '[data-product-json]',
    bundleProductJson: '[data-bundle-products-json]',
    singleOptionSelector: '[data-single-option-selector]',
    addToCartWrapper: '.product-quantity-button',
    modal: {
      item: '.bundle-product-item',
      step: '[data-bundle-step]',
      overlay: '#bundle-modal-overlay',
      wrapper: '.bundle-modal__wrapper',
      overlayClose: '[data-close-modal]',
      btnOpen: '[data-chose-options]',
      btnClose: '[data-bundle-btn-close]',
      btnCloseApprove: '[data-bundle-btn-close-approve]',
      btnCloseContinue: '[data-bundle-btn-continue]',
      btnNext: '[data-bundle-btn-next]',
      btnPrev: '[data-bundle-btn-prev]',
      btnNav: '.bundle-modal__header-button',
      btnEdit: '[data-bundle-btn-edit]',
      productsContainer: '.bundle-final__products',
      addToCart: '[data-bundle-add-to-cart]',
      progressBar: '.bundle-modal__header-bar',
      slideshowsWrapper: '.bundle-product-item__images-wrapper',
      stepMobileTitle: '[data-mobile-step-title]',
      price: '[data-bundle-price]',
      comparePrice: '[data-bundle-compare-price]'
    }
  };

  function ProductBundleItem(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.bundleProducts = JSON.parse($(selectors.bundleProductJson).html());
    this.productsLength = Object.keys(this.bundleProducts).length;

    var options = {
      $container: this.$container,
      enableHistoryState: false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$productdImages = $(selectors.productImage, this.$container);

    this.$container.on('variantChange', this.updateVariant.bind(this));

    if (this.$productdImages.length > 0) {
      this.$container.on('variantImageChange', this.updateProductImage.bind(this));
    }

    this.addToCartWrapperFixed();
    this.changeOptionShadeColor(this);
    this.changeOption(this);
  }

  ProductBundleItem.prototype = $.extend({}, ProductBundleItem.prototype, theme.Product.prototype, {

    updateVariant: function (evt) {
      var variant = evt.variant;
      var btnNext = this.$container.find(selectors.modal.btnNext);
      var btnNavFinal = $(selectors.modal.btnNav).eq(this.productsLength);
      var containerIndex = this.$container.index();
      var btnNavNext = $(selectors.modal.btnNav).eq(containerIndex).nextAll();

      if (variant) {
        var productCurrentVariantSku = $('[data-product-current-variant-sku]');
        var productVariantSku = variant.sku;

        if (productCurrentVariantSku) {
          if (productVariantSku === '') {
            productCurrentVariantSku.parent().eq(containerIndex).hide();
          } else {
            productCurrentVariantSku.parent().eq(containerIndex).show();
            productCurrentVariantSku.eq(containerIndex).text(productVariantSku);
          }
        }

        if (variant.available) {
          var priceFormat = slate.Currency.formatMoney(variant.price, theme.moneyFormat);

          this.$container.attr('data-current-variant-id', variant.id);
          this.$container.attr('data-current-variant-title', variant.title);
          this.$container.attr('data-current-variant-sku', variant.sku);
          this.$container.attr('data-current-variant-product-price', priceFormat);
          this.$container.attr('data-current-variant-barcode', variant.barcode);
          btnNext.attr('disabled', false).text(this.$container.attr('data-btn-next-label'));

          if (btnNavFinal.hasClass('visited')) {
            btnNavNext.attr('disabled', false);
          }
        } else {
          btnNext.attr('disabled', true).text(theme.strings.soldOut);
          btnNavNext.attr('disabled', true);
        }
      }
    },

    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return ProductBundleItem;
})();

theme.ProductBundle = (function() {

  var selectors = {
    originalSelectorId: '[data-product-select]',
    productFeaturedImage: '[data-product-featured-image]',
    productImageId: '[data-product-image-id]',
    productSlideshow: '[data-product-slideshow]',
    productJson: '[data-product-json]',
    productKlaviyoJson: '[data-product-klaviyo-json]',
    bundleProductJson: '[data-bundle-products-json]',
    singleOptionSelector: '[data-single-option-selector]',
    addToCartWrapper: '.product-quantity-button',
    modal: {
      item: '.bundle-product-item',
      step: '[data-bundle-step]',
      overlay: '#bundle-modal-overlay',
      wrapper: '.bundle-modal__wrapper',
      overlayClose: '[data-close-modal]',
      btnOpen: '[data-chose-options]',
      btnClose: '[data-bundle-btn-close]',
      btnCloseApprove: '[data-bundle-btn-close-approve]',
      btnCloseContinue: '[data-bundle-btn-continue]',
      btnNext: '[data-bundle-btn-next]',
      btnPrev: '[data-bundle-btn-prev]',
      btnNav: '.bundle-modal__header-button',
      btnEdit: '[data-bundle-btn-edit]',
      productsContainer: '.bundle-final__products',
      addToCart: '[data-bundle-add-to-cart]',
      progressBar: '.bundle-modal__header-bar',
      slideshowsWrapper: '.bundle-product-item__images-wrapper',
      stepMobileTitle: '[data-mobile-step-title]',
      price: '[data-bundle-price]',
      comparePrice: '[data-bundle-compare-price]',
      productForm: '.product__form',
      productButtonsWrapper: '.bundle-product-item__buttons'
    }
  };

  var players = [];
  var isYoutubeAPIReady = false || window.isYoutubeAPILoaded;
  var defaultYoutubeOptions = {
    height: '720',
    width: '1280',
    playerVars: {
      cc_load_policy: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      autohide: 0,
      controls: 1,
      branding: 0,
      loop: 0,
      rel: 0,
      fs: 0,
      wmode: 'opaque',
      origin: 'https:'
    },
    events: { }
  };

  function ProductBundle(container) {
    var $container = this.$container = $(container);
    var _self = this;

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.bundleSingle = this.$container.attr('data-bundle-single') === 'true';
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.productKlaviyoObject = JSON.parse($(selectors.productKlaviyoJson, this.$container).html());
    this.productCurrentVariantId = this.$container.attr('data-bundle-single-id');
    this.bundleProductsFiltered = JSON.parse($(selectors.bundleProductJson).html());
    this.bundleProducts = {};

    for (let item in this.bundleProductsFiltered) {
      if (!this.bundleProductsFiltered[item]['error']) this.bundleProducts[item] = this.bundleProductsFiltered[item];
    }

    this.productsLength = Object.keys(this.bundleProducts).length;
    this.discountType = this.$container.attr('data-bundle-discount-type');
    this.discountPercentage = parseInt(this.$container.attr('data-bundle-discount-percentage'), 10);
    this.discountFixed = parseInt(this.$container.attr('data-bundle-discount-fixed'), 10);

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';

    this.addToCartWrapperFixed();
    this.clickChoseOptions();
    this.clickNext();
    this.clickPrev();
    this.clickNav();
    this.clickEdit();
    this.clickAddToCart();
    this.closeModal();
    this.mapCurrentVariants(true, false);
    this.initVideoPlayers();
    this.pauseActiveVideo($container);
  }

  ProductBundle.prototype = $.extend({}, ProductBundle.prototype, theme.Product.prototype, {

    clickChoseOptions: function () {
      var _self = this;

      $(document).on('click', selectors.modal.btnOpen, function (evt){
        evt.preventDefault();

        _self.showModal();
      })
    },

    showModal: function () {
      var $modal = $(selectors.modal.overlay);
      var progressBarWidth = 100 / $(selectors.modal.step).length + '%';

      this.progressBarAnimate(progressBarWidth);
      $(selectors.modal.btnNav).attr('disabled', true).eq(0).attr('disabled', false);

      $modal.fadeIn();

      bodyScrollLock.disableBodyScroll($('#bundle-modal__products')[0]);
      this.changeContainer(0);
    },

    hideModal: function () {
      var $modal = $(selectors.modal.overlay);
      bodyScrollLock.clearAllBodyScrollLocks();

      $modal.fadeOut();
    },

    closeModal: function () {
      var _self = this;

      $(selectors.modal.btnClose).on('click', function () {
        if ($(selectors.modal.overlayClose).is(':visible')) {
          _self.hideModal();
          $(selectors.modal.overlayClose).fadeOut();
        } else {
          $(selectors.modal.overlayClose).fadeIn();
        }
      });

      $(selectors.modal.btnCloseApprove).on('click', function () {
        _self.hideModal();
        $(selectors.modal.overlayClose).fadeOut();
      });

      $(selectors.modal.btnCloseContinue).on('click', function () {
        $(selectors.modal.overlayClose).fadeOut();
      });

      $(document).mouseup(function (e){
        var div = $(selectors.modal.wrapper);
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && div.is(':visible')) {
          if ($(selectors.modal.overlayClose).is(':visible')) {
            _self.hideModal();
            $(selectors.modal.overlayClose).fadeOut();
          } else {
            $(selectors.modal.overlayClose).fadeIn();
          }
        }
      });
    },

    changeContainer: function (index) {
      var _self = this;
      $(selectors.modal.step).hide().eq(index).fadeIn();
      $(selectors.modal.stepMobileTitle).hide().eq(index).fadeIn();
      $(selectors.modal.btnNav).eq(index).attr('disabled', false);

      if (index < this.productsLength) {
        $(selectors.modal.item).hide().eq(index).fadeIn('400', function() {
          _self.slideShowReInit(index);

          var buttonsWrapperHeight = $(selectors.modal.item).eq(index).find(selectors.modal.productButtonsWrapper).outerHeight();
          var $productForm = $(selectors.modal.item).eq(index).find(selectors.modal.productForm);

          $productForm.css('padding-bottom', buttonsWrapperHeight + 'px');
        });
      } else {
        $(selectors.modal.btnNav).eq(index).addClass('visited');
        this.mapCurrentVariants(true, true);
      }

    },

    slideShowReInit: function (index) {
      var id = this.bundleProducts[index].id
      var $mainSlideshow = $('[data-product-slideshow="'+ id +'"]');
      var $mainThumbnails = $('[data-product-thumbnails-slideshow="'+ id +'"]');
      var config = $.parseJSON($mainSlideshow.attr('data-slick-config'));
      var configThumbnails = $.parseJSON($mainThumbnails.attr('data-slick-config'));

      if (configThumbnails.arrows) {
        configThumbnails["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M3.979 27L18 13.5 3.979 0 0 3.831 10.045 13.5 0 23.169z" transform="translate(-1285 -338) translate(0 48) translate(408 290) translate(877) matrix(-1 0 0 1 18 0)"/></g></g></svg></button>';
        configThumbnails["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M51.979 27L66 13.5 51.979 0 48 3.831 58.045 13.5 48 23.169z" transform="translate(-1333 -338) translate(0 48) translate(408 290) translate(877)"/></g></g></svg></button>';
      }

      if ($mainSlideshow.hasClass('slick-initialized')) {
        $mainSlideshow.slick('unslick').slick(config);
        $mainThumbnails.slick('unslick').slick(configThumbnails);
      } else {
        $mainSlideshow.slick(config);
        $mainThumbnails.slick(configThumbnails);
      }
    },

    clickNext: function () {
      var _self = this;

      $(selectors.modal.btnNext).on('click', function () {
        var index = parseInt($(this).parents(selectors.modal.item).index(), 10);
        var nextIndex = index + 1;

        var progressBarWidth = 100 / $(selectors.modal.step).length * (nextIndex + 1) + '%';
        _self.progressBarAnimate(progressBarWidth);

        _self.changeContainer(nextIndex);
      });
    },

    clickPrev: function () {
      var _self = this;

      $(selectors.modal.btnPrev, this.$container).on('click', function () {
        var index = parseInt($(this).parents(selectors.modal.item).index(), 10);
        var prevIndex = index - 1;

        var progressBarWidth = 100 / $(selectors.modal.step).length * index + '%';
        _self.progressBarAnimate(progressBarWidth);

        _self.changeContainer(prevIndex);
      });
    },

    clickNav: function () {
      var _self = this;

      $(selectors.modal.btnNav).on('click', function () {
        var index = $(this).index();
        var prevIndex = index - 1;

        var progressBarWidth = 100 / $(selectors.modal.step).length * index + '%';
        _self.progressBarAnimate(progressBarWidth);

        _self.changeContainer(prevIndex);
      });
    },

    clickEdit: function () {
      var _self = this;

      $(document).on('click', selectors.modal.btnEdit, function () {
        var index = $(this).parents('.bundle-final__product').index();

        var progressBarWidth = 100 / $(selectors.modal.step).length * (index + 1) + '%';
        _self.progressBarAnimate(progressBarWidth);

        _self.changeContainer(index);
      });
    },

    checkPrice: function (variantsPrices) {
      var $priceWrapper = $(selectors.modal.price);
      var $comparePriceWrapper = $(selectors.modal.comparePrice);
      var discountType = this.discountType;
      var discountPercentage = this.discountPercentage;
      var discountFixed = this.discountFixed;

      var comparePrice = variantsPrices.reduce(function (accumulator, value) {
        return accumulator + value;
      });

      var price = comparePrice - (comparePrice / 100 * discountPercentage);
      if (discountType != 'percentage') {
        price = comparePrice - discountFixed;
      }

      $priceWrapper.html(slate.Currency.formatMoney(price, theme.moneyFormat));
      $comparePriceWrapper.html(slate.Currency.formatMoney(comparePrice, theme.moneyFormat))
    },

    mapCurrentVariants: function (prices, products) {
      var _self = this;
      var $productsContainerSelector = $(selectors.modal.productsContainer);
      var productsArray = [];
      var pricesArray = [];

      $.map(this.bundleProducts, function(element) {
        var $product = $(element);
        var variants = $product[0].variants;

        if (prices) {
          pricesArray.push( _self.findCurrentVariant(variants, $product).variantPrice);
        }

        if (products) {
          productsArray.push( _self.findCurrentVariant(variants, $product).product[0]);
        }
      });

      if (prices) {
        _self.checkPrice(pricesArray);
      }

      if (products) {
        $productsContainerSelector.empty().append(productsArray);
      }
    },

    findCurrentVariant: function (variants, $product) {
      var _self = this;
      var $productContainer = $(selectors.modal.item);
      var currentVariantPreselected = [];
      var currentVariantIds = $.map( $productContainer, function( elem, i ) {
        var preselectedVariant = $(elem).attr('data-preselected-variant');
        currentVariantPreselected.push(preselectedVariant);
        return $(elem).attr('data-current-variant-id');
      });
      var product = [];
      var variantPrice;

      variants.forEach(function(variant, index) {
        currentVariantIds.forEach(function(id) {
          if (variant.id == id) {
            variantPrice = variant.price;
            product.push(_self.constructionProduct(variant, $product, currentVariantPreselected[index]));
          }
        });
      });

      return {
        product: product,
        variantPrice: variantPrice
      };
    },

    constructionProduct: function (variant, $product, variantPreselected) {
      var title = $product[0].title;
      var options = [];
      var optionsNames = [];

      if (variant.featured_image) {
        var imageAlt = variant.featured_image.alt ? variant.featured_image.alt : title;
        var imageSrc = variant.featured_image.src ? variant.featured_image.src : $product[0].featured_image;
      } else if ($product[0].featured_image) {
        var imageAlt = title;
        var imageSrc = $product[0].featured_image ? $product[0].featured_image : false;
      }

      $product[0].options.forEach(function(elem, i) {
        if (elem != 'Title') {
          if (variantPreselected === 'false') {
            optionsNames.push('<span>'+ elem +'</span>');
          }
          options.push('<p><span>'+ elem +':</span> <span>'+ variant.options[i] +'</span></p>');
        }
      });

      optionsNames = optionsNames.length > 1 ? 'options' : optionsNames;

      return '<div class="bundle-final__product">' +
        '<div class="bundle-final__product-img-wrapper"><img class="lazyload bundle-final__product-img"' +
        ' data-sizes="auto"' +
        ' data-src="'+ imageSrc +'"' +
        ' data-parent-fit="contain"' +
        ' alt="'+ imageAlt +'"/></div>' +
        '<div class="bundle-final__product-content">' +
        '<h2 class="bundle-final__product-title">'+ title +'</h2>' +
        '<div class="bundle-final__product-options">'+ options +'</div>' +
        '<button class="bundle-final__product-edit btn " data-bundle-btn-edit>edit '+
        '<span>'+ optionsNames +'</span></button>' + '' +
        '</div>' +
        '</div>'
    },

    progressBarAnimate: function (width) {
      $(selectors.modal.progressBar).animate({
        width: width
      }, 500);
    },

    clickAddToCart: function () {
      var _self = this;
      var $productContainer = $(selectors.modal.item);

      theme.quantitySelectors();

      $(selectors.modal.addToCart).on('click', function (evt) {
        evt.preventDefault();
        var $thisContainer = $(this).parents(selectors.modal.step);
        var productsData;

        var quantityValue = parseInt($thisContainer.find('#quantity').val(), 10);

        if (_self.bundleSingle) {
          var props = {};
          var propProductsTitles = '';
          $.each( $productContainer, function( i, elem ) {
            var id = $(elem).attr('data-current-variant-id');
            var productTitle = $(elem).attr('data-current-variant-product-title');
            var productPrice = $(elem).attr('data-current-variant-product-price');
            var variantTitle = $(elem).attr('data-current-variant-title');
            var sku = $(elem).attr('data-current-variant-sku') || undefined;
            var barcode = $(elem).attr('data-current-variant-barcode') || undefined;
            var propName = `_product ${i + 1}`;
            var propValue = `id: ${id}, product_title: ${productTitle}, variant_title: ${variantTitle}, sku: ${sku}, barcode: ${barcode}, price: ${productPrice}`;
            var propTitle = variantTitle == 'Default Title' ? productTitle : `${productTitle} - ${variantTitle}`;

            propProductsTitles+= `${propTitle}; `

            props[propName] = propValue;
          });

          props['Products'] = propProductsTitles;
          _self.productKlaviyoObject['SelectedProductsInBundle'] = propProductsTitles;

          productsData = [{
            id: _self.productCurrentVariantId,
            quantity: quantityValue,
            properties: props
          }]
        } else {
          productsData = $.map( $productContainer, function( elem, i ) {
            return {
              id: $(elem).attr('data-current-variant-id'),
              quantity: quantityValue,
            };
          });
        }
        _self.ajaxBundleAddToCart({items: productsData});
      });
    },

    ajaxBundleAddToCart: function (data) {
      var _self = this;
      var errorContainer = this.$container.find('[data-bundle-form-error]');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data
      }).done(function () {
        $(document).trigger('product:added');
        $(selectors.modal.addToCart).prop('disabled', false);

        _self.hideModal();

        if (errorContainer.length) {
          errorContainer.slideUp();
        }

        if (_self.bundleSingle) {
          var _learnq = window._learnq || [];
          _learnq.push(['track', 'Added to Cart', _self.productKlaviyoObject]);
        }

      }).fail(function (error) {
        if (error.status === 422 && errorContainer.length) {
          errorContainer.text(error.responseJSON.description);
          errorContainer.slideDown();
        }
        console.log(error);
        $(selectors.modal.addToCart).prop('disabled', false);
      })
    },

    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return ProductBundle;
})();


theme.Slideshow = (function() {

  function Slideshow(container) {
    this.$container = $(container);
    var config = $.parseJSON($(container).attr('data-slick-config'));
    let filteredItems = null;
    
    this.$container.on('filterSlideshowByCountry', function () {
      removeItemsWithoutCountry();
    });

    function init() {
      const slickFilterSelector = $(container).attr('data-slick-filter');
      if ($(container).hasClass('product__images')) {
        config["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M3.979 27L18 13.5 3.979 0 0 3.831 10.045 13.5 0 23.169z" transform="translate(-1285 -338) translate(0 48) translate(408 290) translate(877) matrix(-1 0 0 1 18 0)"/></g></g></svg></button>';
        config["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M51.979 27L66 13.5 51.979 0 48 3.831 58.045 13.5 48 23.169z" transform="translate(-1333 -338) translate(0 48) translate(408 290) translate(877)"/></g></g></svg></button>';
      }
      
      if (slickFilterSelector && slickFilterSelector !== '') {
        filteredItems = $(slickFilterSelector, $(container));
      }
      
      if (config.arrows) {
        config["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 12 18" fill="none"><path d="M10.2422 1L1.99976 9L10.2422 17" stroke="#392C22" style="stroke-width: 4px;"/></svg></button>';
        config["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 12 18" fill="none"><path d="M1.42383 1L9.66625 9L1.42383 17" stroke="#392C22" style="stroke-width: 4px;"/></svg></button>';
      }
      
      if (config.appendArrows) {
        config["appendArrows"] = $(config.appendArrows);
      }

      if (config) {
        $(container).slick(config);
        if (filteredItems && filteredItems.length) {
          $(container).slick('slickFilter', filteredItems);
          $(container).slick('getSlick').$slides.each(function(index, element) { $(element).attr('data-slick-index', index); });
        }
  
        if (config.responsive) {
          config.responsive.forEach(function (breakpoint) {
            if (breakpoint.breakpoint === 767 && breakpoint.settings.dots || config.dots && !breakpoint.settings.dots) {
              var dotsManager = new ClassDotsManager($(container).parent(), $(container).find('.slick-slide').length, 6);
              dotsManager.init();

              $(container).on("afterChange", function (slick, currentSlide) {
                dotsManager.updateDots(currentSlide.currentSlide, 'true');
              });

              var thisResize = false;
              $(window).on('resize', ($.throttle(1000, function () {
                if ($(window).width() < 768 && thisResize) {
                  $(container).slick('slickGoTo', 0);
                  dotsManager.updateDots(0, 'false');
                  thisResize = false;
                } else if (!thisResize && $(window).width() > 767) {
                  thisResize = true;
                }
              })));
            }
          });
        }
      }

      if ($(container).hasClass('product__images-thumbnails')) {
        $(window).on('load', function () {
          $(container).css('pointer-events', 'auto');
          $(container).find('.slick-slide').css('pointer-events', 'auto');
          $(container).find('.slick-arrow').css('pointer-events', 'auto');
          
          const activeDotsIndex = $(container).parent().find('.slick-dots li.slick-active').index();
          if (activeDotsIndex >= 0) {
            $(container).slick('slickGoTo', $(container).parent().find('.slick-dots li.slick-active').index());
          }
        });

        $(window).on('orientationchange', function () {
          if ($(container).find('.slick-slide').length <= 5) {
            $(container).slick('slickGoTo', 0);
          }
        });
      }
    }

    function ClassDotsManager(slickElement, numOfItems, numOfDots) {
      // this.listDotsElement = slickElement.find('.slick-dots li');
      this.numOfDots = numOfDots <= numOfItems ? numOfDots : numOfItems;
      this.minIndex = 0;
      this.maxIndex = numOfDots - 1;
      this.showDotsBetween = function (minIndex, maxIndex) {
        slickElement.find('.slick-dots li').filter(function (index) {
          $(this).css("display", index >= minIndex && index <= maxIndex ? "inline-block" : "none");
        });
      };
      this.init = function () {
        this.showDotsBetween(0, this.numOfDots - 1);
      };
      this.updateDots = function (newIndex, doNotUpdate = 'false') {

        if (newIndex >= this.minIndex && newIndex <= this.maxIndex && doNotUpdate == 'true') {
          // don't need to update
        } else {
          if (newIndex > this.maxIndex) {
            this.maxIndex = newIndex;
            this.minIndex = this.maxIndex - this.numOfDots + 1;
          } else {
            this.minIndex = newIndex;
            this.maxIndex = this.minIndex + this.numOfDots - 1;
          }
          this.showDotsBetween(this.minIndex, this.maxIndex);
        }
      };
    }

    function removeItemsWithoutCountry() {
      var country = sessionStorage.getItem("userCountryIsoCode");

      if (!country) {return false}

      var slides = $(container).find('.slick-slide');

      if (slides.length > 1) {
        $(container).slick('slickFilter', function() {
          return $(this).attr('data-country-filter').includes(country.toLowerCase())  || $(this).attr('data-country-filter') == 'all';
        });
      }
    }

    init();
  }

  return Slideshow;
})();

theme.EmbedNativeVideo = (function() {

  var players = [];
  var isYoutubeAPIReady = false;
  var defaultYoutubeOptions = {
    height: '720',
    width: '1280',
    playerVars: {
      cc_load_policy: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      autohide: 0,
      controls: 1,
      branding: 0,
      loop: 0,
      rel: 0,
      fs: 0,
      wmode: 'opaque',
      origin: 'https://www.youtube.com/'
    },
    events: {
      'onReady': onPlayerReady
    }
  };

  function EmbedNativeVideo(container) {
    var self = this;
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var $player = this.$player = $container.find('.video__iframe') || $container.find('video') ;

    if ($player.length) {
      this.playerID = $player.find('[data-youtube-wrapper]').attr('id');
      this.videoID = $player.data('video-id');
      this.videoType = $player.data('video-type');
      this.init($container);
    }

    $container.on('touchstart', '.video-wrapper', function(e) {
      var playerID = $(this).find('.video__iframe').attr('id');
      players[playerID].playVideo();
    });
  }

  function onPlayerReady(event) {
    var id = $(event.target.h).attr('id');
    var wrapperId = $(event.target.h).attr('data-section-this-id') || $(event.target.i).attr('data-section-this-id') || $(event.target.o).attr('data-section-this-id');
    var container = $('[data-section-id="'+ wrapperId +'"]');
    var $button = container.find('.video-play');
    var $image = container.find('.video-image');
    var disabledSound = $( '#' + id ).attr( 'data-enable-sound' ) == 'true' ? true : false;

    if(typeof $(event.target.l)[0] == 'object') {
      $(event.target.l).attr('tabindex', '-1');
    }

    if ( disabledSound ) {
      event.target.mute();
    } else {
      event.target.unMute();
    }
    
    $button.on('click', function () {
      event.target.playVideo();
      $image.fadeOut();
      $(this).hide();
    })
  }

  EmbedNativeVideo.prototype = $.extend({}, EmbedNativeVideo.prototype, {
    init: function($container) {
      var _self = this;

      if ( _self.videoType == 'youtube'){
        if ( isYoutubeAPIReady ) {
          this.loadYoutubePlayer();
        } else {
          // Load Youtube API if not loaded yet
          window.loadYoutubeAPI();
          $('body').on('youtubeAPIReady', this.loadYoutubePlayer.bind(this));
        }
      }
      else if ( _self.videoType == 'vimeo'){
        var iframe = $container.find('iframe');
        var player = new Vimeo.Player(iframe, {
          autoplay: true
        });
        var $button = $container.find('.video-play');
        var $image = $container.find('.video-image');
        var disabledSound = iframe.attr( 'data-enable-sound' ) == 'true' ? true : false;

        player.ready().then(function() {
          if ( disabledSound ) {
            player.setVolume(0);
          } else player.setVolume(1);

          $button.on('click', function () {
            player.play();
            $image.fadeOut();
            $(this).hide();
          })
        });

      } else {
        var $video = $container.find('video');
        var $button = $container.find('.video-play');
        var $image = $container.find('.video-image');

        $button.on('click', function() {
          $video.attr('controls', true);
          $image.fadeOut();
          $video.trigger('play');
          $(this).hide();
        });
      }
    },

    loadYoutubePlayer: function() {
      var currentYoutubeOptions = $.extend({}, defaultYoutubeOptions);
      currentYoutubeOptions.videoId = this.videoID;

      if (this.videoID.length){
        players[this.playerID] = new YT.Player( this.playerID , currentYoutubeOptions );
      }

      isYoutubeAPIReady = true;
    },

    onUnload: function(evt) {
      var playerID = 'youtube-' + this.$container.data('section-id');
      players[playerID].destroy();
    }
  });

  return EmbedNativeVideo;
})();

theme.Header = (function() {

  function Header(container) {
    this.$container = $(container);
    var _self = this;
    var $buttonModal = '.mobile-menu__sidebar-button[aria-controls]:not(.mobile-menu-icon)';

    _self.headerSticky();

    _self.searchToggle();

    _self.hoverMegaMenuLink();

    _self.handleMegaMenuKeyboard();

    $(document).on('click', '.close', function () {
      var id = $(this).parents('.mobile-menu__sidebar').attr('id');

      _self.closeSidebar(id);
    });

    $(document).on('click', $buttonModal, function (e) {
      e.preventDefault();
      var thisId = $(this).attr('aria-controls');

      _self.openSidebar(thisId);
    });

    $(document).on('click', '[data-action="open-drawer"]', function (e) {
      e.preventDefault();
      var thisId = $(this).attr('aria-controls');

      $(this).attr('data-action', 'close-drawer');
      _self.openSidebar(thisId);
    });

    $(document).on('click', '[data-action="close-drawer"]', function (e) {
      e.preventDefault();
      var id = $(this).parents('.mobile-menu__sidebar').attr('id');

      _self.closeSidebar(id);
      $(this).attr('data-action', 'open-drawer');
    });

    $(document).mouseup(function (e){
      var div = $('.mobile-menu__sidebar[aria-hidden="false"]');
      var divChild = div.find('.insert[aria-hidden="false"]');
      var buttonClose = $('[data-action="close-drawer"]');

      if (!div.is(e.target)
        && div.has(e.target).length === 0
        && !divChild.is(e.target)
        && divChild.has(e.target).length === 0
        && !buttonClose.is(e.target)
        && buttonClose.has(e.target).length === 0) {
        _self.closeSidebar();
        $('[data-action="close-drawer"]').attr('data-action', 'open-drawer');
      }
    });

    $( window ).on('orientationchange', function () {
      _self.closeSidebar();
      $('[data-action="close-drawer"]').attr('data-action', 'open-drawer');
    });

    $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        _self.closeSidebar();
        $('[data-action="close-drawer"]').attr('data-action', 'open-drawer');
      }
    });

    $(window).on('scroll orientationchange', $.throttle(300, function () {
      _self.headerSticky();
    }));
  }

  Header.prototype = $.extend({}, Header.prototype, {

    openSidebar: function(id) {
      var thisModal = $('#' + id);
      var promoBarButton = $('.promo-bar__button');
      var headerHeight = $('.header-inner').outerHeight() ? $('.header-inner').outerHeight() : 0;
      var headerPromo = $('.promo-bar').outerHeight() ? $('.promo-bar').outerHeight() : 0;
      var stickyStart = (headerPromo + headerHeight);

      if (!thisModal) {
        return;
      }

      bodyScrollLock.clearAllBodyScrollLocks();
      bodyScrollLock.disableBodyScroll(thisModal.find('.mobile-menu__sidebar-wrapper')[0]);

      if (promoBarButton.attr('aria-expanded') == 'true') {
        promoBarButton.trigger('click');
        $('html, body').animate({ scrollTop: 0 });
      }

      if ($(window).scrollTop() < stickyStart) {
        $('html, body').animate({ scrollTop: 0 });
      }

      thisModal.attr('aria-hidden', 'false');
      $('body').addClass('mobile-menu__sidebar--open');
      $('html').addClass('mobile-menu__sidebar--open');
      $('.header').addClass('mobile-menu__sidebar--open');
    },

    closeSidebar: function(id) {
      var thisModal;

      if (!$('html').hasClass('mobile-menu__sidebar--open')) {
        return
      }

      if (id) {
        thisModal = $('.mobile-menu__sidebar[id="' + id + '"]');
      } else {
        thisModal = $('.mobile-menu__sidebar[aria-hidden="false"]');
      }

      thisModal.attr('aria-hidden', 'true');
      thisModal.css('height', '');
      if (!thisModal.parents('.mobile-menu__sidebar').length) {
        $('body').removeClass('mobile-menu__sidebar--open');
        $('html').removeClass('mobile-menu__sidebar--open');
        $('.header').removeClass('mobile-menu__sidebar--open');
      } else if (id == undefined && thisModal.parents('.mobile-menu__sidebar').length) {
        $('body').removeClass('mobile-menu__sidebar--open');
        $('html').removeClass('mobile-menu__sidebar--open');
        $('.header').removeClass('mobile-menu__sidebar--open');
      }

      if ($('.mobile-menu__sidebar[aria-hidden="false"]').length) {
        bodyScrollLock.clearAllBodyScrollLocks();
        bodyScrollLock.disableBodyScroll($('.mobile-menu__sidebar[aria-hidden="false"]').find('.mobile-menu__sidebar-wrapper')[0]);
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    },

    lastScrollPos: 0,

    headerSticky: function () {
      const scrollY = window.scrollY;
      const $header = $('.header');
      const headerHeight = $('.header-inner').outerHeight() ? $('.header-inner').outerHeight() : 0;
      const headerPromoBar = $('.promo-bar__content').outerHeight() ? $('.promo-bar__content').outerHeight() : 0;
      const headerPromo = $('.promo-bar').outerHeight() ? $('.promo-bar').outerHeight() : 0;
      const $headerSticky = $('.header .header-menu:not(.header-site-switch)');
      const mobileCollection = $('.mobile-rec-collections');
      const mobileCollectionHeight = $('.mobile-rec-collections').outerHeight() ? $('.mobile-rec-collections').outerHeight() : 0;
      const stickyStart = (headerPromo + headerHeight + mobileCollectionHeight) * 2;
      
      if(this.lastScrollPos > scrollY && !$('body').hasClass('header--show-tabs')) {
        $('body').addClass('header--show-tabs');
      } else if (this.lastScrollPos < scrollY && $('body').hasClass('header--show-tabs')) {
        $('body').removeClass('header--show-tabs');
      }
      
      this.lastScrollPos = scrollY;
  
      if ($(window).scrollTop() >= stickyStart) {
        if (!$header.hasClass('header--sticky')) {
          if (mobileCollection.length) {
            mobileCollection.hide();
          }
          
          $header.addClass('header--sticky');
          var $links = $('.header__nav-item').removeClass('active');
          $headerSticky.css('display', 'flex').hide().fadeIn(600);
        }
      } else {
        if ($header.hasClass('header--sticky')) {
          if (mobileCollection.length) {
            mobileCollection.show();
          }

          $header.removeClass('header--sticky').css('display', '');
          $headerSticky.css('display', '');
        }
      }

      var windowWidth = $(window).width();

      if (windowWidth < 989) {
        if ($(window).scrollTop() < headerPromoBar) {
          document.documentElement.style
            .setProperty('--mobile-sidebar-top',  headerHeight + headerPromoBar - $(window).scrollTop() + 'px');
        } else {
          document.documentElement.style
            .setProperty('--mobile-sidebar-top',  headerHeight + 'px');
        }
      }
    },

    searchToggle: function () {
      var uncheck = true;
      var mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          var $icon = $('.search-modal__label');
          var $recProducts = $('.search-wgt-rec');
          var $body = $(mutation.target);
          bodyScrollLock.clearAllBodyScrollLocks();

          if ($('.search-modal').is(':visible')) {
            if ($body.hasClass('snize-instant-widget-is-open') && uncheck) {
              uncheck = false;
              $recProducts.fadeOut('0', function () {
                bodyScrollLock.disableBodyScroll($('.snize-ac-results .snize-ac-results-content')[0]);
              });
            } else if (!$body.hasClass('snize-instant-widget-is-open') && !uncheck) {
              uncheck = true
              $recProducts.fadeIn(300, function () {
                bodyScrollLock.disableBodyScroll($('.search-wgt-rec')[0]);
              });
            }
          }

        });
      });

      mutationObserver.observe(document.querySelector('body'), {
        attributes: true
      });

      $(document).on('click', '.open-search', function (evt) {
        evt.preventDefault();

        bodyScrollLock.disableBodyScroll($('.search-wgt-rec')[0]);

        $('.search-modal').fadeIn(200, function () {
          $('.search-modal__input')[0].click();
          $('.search-modal__input')[0].focus();
        });

        function getFocusableElement () {
          var focusableSelectors = `
          a[href], button:not([disabled]),
          textarea, input:not([disabled]),
          select, [tabindex]:not([tabindex="-1"])
          `;

          var $focusable = $('.search-modal')
            .find(focusableSelectors)
            .filter(':visible');
          return $focusable;
        }

        $('.search-modal').on('keydown', function (e) {
          var $focusable = getFocusableElement();
          var $firstEl = $focusable.first()[0];
          var $lastEl =  $focusable.last()[0];
          if (!$focusable || !$focusable.length) return;

          console.log($focusable, '$focusable')

          if (e.key === 'Escape' || e.keyCode === 27) {
            e.preventDefault();
            bodyScrollLock.clearAllBodyScrollLocks();

            $('body').removeClass('snize-instant-widget-is-open');
            $('.snize-ac-results').hide();

            $('.search-modal').fadeOut(200);
            return;
          }

          if (e.key === 'Tab') {
            if ($focusable.length === 0) return;
            if (e.shiftKey) {
              if (document.activeElement === $firstEl) {
                e.preventDefault();
                $lastEl.focus();
              }
            } else {
              if (document.activeElement === $lastEl) {
                e.preventDefault();
                $firstEl.focus()
              }
            }
          }
        })
      });

      $(document).on('click', '.search-modal__btn-close', function () {
        bodyScrollLock.clearAllBodyScrollLocks();

        $('body').removeClass('snize-instant-widget-is-open');
        $('.snize-ac-results').hide();

        $('.search-modal').fadeOut(200);
        $('.open-search').focus();
      });
    },

    hoverMegaMenuLink: function () {
      var $link = $('.header__nav-item');
      var $list = $('.header__nav-list');

      $link.on('mouseenter', function () {
        $link.removeClass('active').find('a[aria-haspopup="true"]').attr('aria-expanded', 'false');
        $(this).addClass('active').find('a[aria-haspopup="true"]').attr('aria-expanded', 'true');
        $(this).find('.megamenu').attr('aria-hidden', 'false');
      });

      $list.on('mouseleave', function () {
        $link.removeClass('active').find('a[aria-haspopup="true"]').attr('aria-expanded', 'false');
        $link.find('.megamenu').attr('aria-hidden', 'true');
      });
    },
    handleMegaMenuKeyboard: function () {
      var $header = $('.header');
      var $link = $('.header__nav-item');
      var $menuItems = $('.header__nav-item > a[aria-haspopup="true"]');
      var $menuItemsLinks = $('.header__nav-item > a[aria-haspopup="false"]');

      $menuItems.each(function() {
        var $trigger = $(this);
        var $item = $trigger.closest('.header__nav-item');
        var $dropdown = $item.find('.megamenu');

        $trigger.on('focus', function (e) {
          $link.removeClass('active').find('a[aria-haspopup="true"]').attr('aria-expanded', 'false');
          $link.find('.megamenu').attr('aria-hidden', 'true');
          $item.addClass('active');
          $trigger.attr('aria-expanded', 'true');
          $dropdown.attr('aria-hidden', 'false');
        })
      })

      $menuItemsLinks.on('focus', function (e) {
        $link.removeClass('active').find('a[aria-haspopup="true"]').attr('aria-expanded', 'false');
        $link.find('.megamenu').attr('aria-hidden', 'true');
      });

      $header.on('focusout', function () {
        setTimeout(function () {
          if (!$header.find(':focus').length) {
            $link.removeClass('active').find('a[aria-haspopup="true"]').attr('aria-expanded', 'false');
            $link.find('.megamenu').attr('aria-hidden', 'true');
          }
        }, 0);
      });
    }
  });

  return Header;
})();

theme.PromoBar = (function() {

  function PromoBar(container) {
    this.$container = $(container);
    var _self = this;
    var $button = $(container).find('.promo-bar__button');
    var $modal = $(container).find('.promo-bar__modal');

    if (!$modal.length) {
      return;
    }

    $(window).on( "load", function() {
      $button.prop("disabled", false);
    });

    var $slideshow = $(container).find('.promo-bar__modal-slideshow');
    var slideshowСonfig = $.parseJSON($slideshow.attr('data-slick-config'));

    if (slideshowСonfig.arrows) {
      slideshowСonfig["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M3.979 27L18 13.5 3.979 0 0 3.831 10.045 13.5 0 23.169z" transform="translate(-1285 -338) translate(0 48) translate(408 290) translate(877) matrix(-1 0 0 1 18 0)"/></g></g></svg></button>';
      slideshowСonfig["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M51.979 27L66 13.5 51.979 0 48 3.831 58.045 13.5 48 23.169z" transform="translate(-1333 -338) translate(0 48) translate(408 290) translate(877)"/></g></g></svg></button>';
    }

    $( window ).on('orientationchange resize', function () {
      if ($button.attr('aria-expanded') === 'true') {
        $button.attr('aria-expanded', $button.attr('aria-expanded') === 'false' ? 'true' : 'false');
        $modal.slideUp('600');
      }
      if ($slideshow.hasClass('slick-initialized')) {
        $slideshow.slick('unslick');
      }
      document.documentElement.style
        .setProperty('--promo-height', $(container).outerHeight() + 'px');
    });

    $button.on('click', function () {
      $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false' ? 'true' : 'false');
      $modal.slideToggle('600', function() {
        if ($(this).is(':visible')) {
          if (!$slideshow.hasClass('slick-initialized')) {
            $slideshow.slick(slideshowСonfig);
          }
        }

        document.documentElement.style
          .setProperty('--promo-height', $(container).outerHeight() + 'px');
      });
    });

    function customDot ($sliderDots) {
      if (!$sliderDots) {
        return
      }

      if ($sliderDots.find('li:not(.custom-dot)').length < 2) {
        $sliderDots.animate({
          height: '0',
          margin: '0'
        }, 300).slideUp();
      }

      $sliderDots.parents('.slick-slider').slick('slickGoTo', 0);

      var activeDotsIndex = $sliderDots.find('.slick-active').index();
      var dotsLength = $sliderDots.find('li:not(.custom-dot)').length;
      var dotWidth = 100 / dotsLength;
      var dotLeft = (100 / dotsLength) * activeDotsIndex;

      if (!$sliderDots.find('.custom-dot').length) {
        $sliderDots.append('<li class="custom-dot" style="width: '+ dotWidth +'%; left:'+ dotLeft +'%"></li>');
      }
    }

    customDot($slideshow.find('.slick-dots'));

    $slideshow.on('init', $.debounce(200, function(event, slick, breakpoint) {
      $slideshow.slick('slickGoTo', 0);

      customDot(slick.$dots);
    }));

    $slideshow.on('beforeChange', $.debounce(200, function(event, slick, currentSlide, nextSlide) {
      var slickSpeed = slideshowСonfig.autoplay == true ? slideshowСonfig.autoplaySpeed : slideshowСonfig.speed;

      if (slick.$dots) {
        var activeDotsIndex = slick.$dots.find('.slick-active').index();
        var $customDot = slick.$dots.find('.custom-dot');
        var dotsLength = slick.$dots.find('li:not(.custom-dot)').length;
        var dotWidth = 100 / dotsLength;

        if (currentSlide > nextSlide) {
          $customDot.animate({
            left: dotWidth * activeDotsIndex + '%',
          }, slickSpeed)

        } else {
          $customDot.animate({
            left: dotWidth * activeDotsIndex + '%',
          }, slickSpeed)
        }
      }
    }));
  }

  return PromoBar;
})();

theme.RunningText = (function() {
  function RunningText(container) {
    var $container = this.$container = $(container);
    var $slide = $container.find('.running-text-line');
    var sliderSpeed = parseInt($container.attr('data-running-speed'), 10);

    if ($slide.length == 1) {
      $slide.clone().appendTo($container);
    }

    $container.slick({
      speed: sliderSpeed,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      arrows: false
    });

  }

  return RunningText;
})();

theme.VideoProducts = (function() {

  function VideoProducts(container) {
    this.$container = $(container);
    var _self = this;
    var $button = $(container).find('.video-products__btn');
    var $runningText = $(container).find('.video-products__running-text');
    var $videoWrapper = $(container).find('.video-products__video');

    $button.on('click', function(event){
      event.preventDefault();
      var width = $(window).width();
      var $currentTarget = $(event.currentTarget);
      $currentTarget.attr('aria-expanded', $currentTarget.attr('aria-expanded')=='false' ? 'true' : 'false');
      $currentTarget.find('span:first-child').text($currentTarget.find('span:first-child').text()==$currentTarget.attr('data-close-label') ? $currentTarget.attr('data-open-label') : $currentTarget.attr('data-close-label'));
      var toggleID = $currentTarget.attr('aria-controls');

      if (width >= 1200) {
        $( '#'+ toggleID ).children().hide();

        $( '#'+ toggleID ).animate({
          opacity: 'toggle',
          width: 'toggle'
        }, 300, function () {
          $( '#'+ toggleID ).children().fadeIn();
        });
        $videoWrapper.toggleClass('border');

        if ($currentTarget.attr('aria-expanded') == 'true') {
          $runningText.animate({ width:'75%' }, 300)
        } else $runningText.animate({ width:'100%' }, 300);

      } else if (width >= 768 && width < 1200) {
        $( '#'+ toggleID ).children().hide();

        $( '#'+ toggleID ).animate({
          opacity: 'toggle',
          width: 'toggle'
        },  300, function () {
          $( '#'+ toggleID ).children().fadeIn();
        });
        $videoWrapper.toggleClass('border');

        if ($currentTarget.attr('aria-expanded') == 'true') {
          $runningText.animate({ width:'65%' }, 300)
        } else $runningText.animate({ width:'100%' }, 300);

      } else if (width < 768) {
        $( '#'+ toggleID ).slideToggle();
        $videoWrapper.toggleClass('border');
      }

    });
  }

  return VideoProducts;
})();

theme.VideoProductsBlock = (function () {

  function VideoProducts(container) {
    this.$container = $(container);
    let _self = this,
        $button = $(container).find('.video-products__btn'),
        $buttonClose = $(container).find('.video-products__products-close');

    $button.on('click', function (event) {
      event.preventDefault();

      let width = $(window).width(),
          $currentPage = $('.page-video'),
          $currentTarget = $(event.currentTarget),
          toggleID = $currentTarget.attr('aria-controls'),
          $productsWrapper = $('#' + toggleID),
          $buttonThatOpened = $currentTarget.parents('.page-video').find('.video-products__btn--block[aria-expanded="false"]').not($currentTarget),

          //---For set height to products wrapper
          productsWrapperInnerHeight = $productsWrapper.find('.video-products__products').outerHeight(),
          size = productsWrapperInnerHeight <= window.innerWidth / 2 ? `${productsWrapperInnerHeight}` : '60vw';

          //---To check if the current block is the last one
      if (width > 749) {
         var currentPageBottom = $currentPage[0].getBoundingClientRect().bottom,
             productsWrapperBottomPlus = $productsWrapper[0].getBoundingClientRect().bottom  + 100;
      }

      if ($currentTarget.attr('aria-expanded') == 'false') {
        closeProducsWrapper($currentTarget, $productsWrapper);
      } else {
        openProducsWrapper($currentTarget, $productsWrapper, size);
      }

      function closeProducsWrapper(currentTarget, productsWrapper) {
        currentTarget.attr('aria-expanded', 'true');
        productsWrapper.animate({
          height: '0vw'
        }, 300, function () {
          productsWrapper.children().hide();
          productsWrapper.css({'z-index': 'unset', 'top': '100%'});
        });
      }

      function openProducsWrapper(currentTarget, productsWrapper, size) {

        if ($buttonThatOpened.length) {
          closeProducsWrapper($buttonThatOpened, $('#' + $buttonThatOpened.attr('aria-controls')));
        }

        if (width > 749 && productsWrapperBottomPlus >= currentPageBottom) {
          productsWrapper.css({'bottom': '0', 'top': 'unset'});
        }

        currentTarget.attr('aria-expanded', 'false');
        productsWrapper.children().show();
        productsWrapper.css('z-index', 1);
        productsWrapper.animate({
          height: size
        }, 300, function () {
          let productsWrapperBottom = $productsWrapper[0].getBoundingClientRect().bottom;

          if (productsWrapperBottom > currentPageBottom) {
            $productsWrapper.css('height',  $productsWrapper.outerHeight() - (productsWrapperBottom - currentPageBottom));
          }
        });
      }
    });

    $buttonClose.on('click', function () {
      $buttonClose.parents('.video-products__wrapper').find('.video-products__btn').trigger('click');
    });
  }

  return VideoProducts;
})();

theme.Blog = (function () {

  function Blog(container) {
    var $container = this.$container = $(container);

    this.ajaxPaginate();
  }


  Blog.prototype = $.extend({}, Blog.prototype, {

    ajaxPaginate: function () {
      var endlessClick = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'scroll',
        offset: 1000
      });
    },
  });
  return Blog;
})();
theme.Collection = (function () {

  function Collection(container) {
    var $container = this.$container = $(container);

    this.ajaxPaginate();
    this.tagFilter();
    this.sortByFilter();
    this.windowHistoryManipulation();
    this.changeSortByOption();
    this.catchFocusOfSortList()
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    ajaxPaginate: function () {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'scroll',
        offset: 1000,
        callback: function () {
          var sections = new slate.Sections();
          sections.register('product-budge-count', theme.ProductBudgeCount);
          sections.register('quick-add', theme.quickAdd);
        }
      });
    },

    tagFilter: function () {
      var _self = this;

      $(document).on('click', '.collection-filters__btn', function (evt) {
        evt.preventDefault();
        var url = $(this).attr('href');

        if(location.search.length) {
          url = url + location.search;
        }

        $(this).css("pointer-events", "none");
        _self.ajaxQuery(url);
      });
    },

    sortByFilter: function () {
      var _self = this;

      Shopify.queryParams = {};
      if(location.search.length) {
        for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      $(document).on('change', '#collection-filter-sort__input', function(e) {
        e.stopPropagation();
        var value = e.currentTarget.value;
        Shopify.queryParams.sort_by = value;

        var search = new URLSearchParams(Shopify.queryParams).toString();
        var url = (value == '') ? window.location.pathname : window.location.pathname + '?' + search;
        
        _self.ajaxQuery(url);
      });
    },

    ajaxQuery: function (url, historyNoPush) {
      var _self = this;

      $.ajax({
        type: 'GET',
        url: url,
      }).done(function (data) {
        var content = $(data).find('.collection-template__wrapper');
        var sections = new slate.Sections();
  
        $('.collection-template').html(content);

        _self.ajaxPaginate();
        sections.register('product-budge-count', theme.ProductBudgeCount);
        sections.register('quick-add', theme.quickAdd);

        if (!historyNoPush) {
          var newurl = window.location.protocol + '//' + window.location.host + url;
          window.history.pushState({path: newurl}, '', newurl);
        }
      }).fail(function (e) {
        console.error(e);
      });
    },

    windowHistoryManipulation: function () {
      var _self = this;

      window.onpopstate = function(event) {
        _self.ajaxQuery(event.state.path, true);
      };
    },

    changeSortByOption: function() {
      $(document).on('click', '.collection-filter-sort__button', function () {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle();

        var isExpanded = $(this).parent().find('.collection-filter-sort__button').attr('aria-expanded') === 'true';
        $(this).parent().find('.collection-filter-sort__button').attr('aria-expanded', !isExpanded);
        var isHidden = $(this).next().attr('aria-hidden') === 'true';
        $(this).next().attr('aria-hidden', !isHidden);
      });

      $(document).mouseup(function (e){
        var div = $('.collection-filter-sort .collection-filter-sort__list');
        var parentDiv = $('.collection-filter-sort .collection-filter-sort__button');
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {

          $('.collection-filter-sort .collection-filter-sort__inner').removeClass('active');
          $('.collection-filter-sort__inner .collection-filter-sort__button').attr('aria-expanded', 'false');
          $('.collection-filter-sort .collection-filter-sort__list').slideUp().attr('aria-hidden', 'true');
        }
      });

      $(document).on('click', '.collection-filter-sort__item', function () {
        var value = $(this).attr('data-value');
        var text = $(this).text();
        var $parent = $(this).parents('.collection-filter-sort');
        var $input = $parent.find('#collection-filter-sort__input');
        var $sortValue = $parent.find('.collection-filter-sort__value');

        $parent.find('.collection-filter-sort__inner').removeClass('active');
        $parent.find('.collection-filter-sort__list').slideUp();
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');

        $sortValue.html(text);
        $input.val(value).trigger('change');
      });
    },
    catchFocusOfSortList: function() {
      $(document).on('keydown', '.collection-filter-sort__list', function (e) {
        var $focusable =$(this).find('.collection-filter-sort__item').not('.selected').find('button');
        var first = $focusable.first()[0];
        var last = $focusable.last()[0];

        if (e.key === 'Escape' || e.keyCode === 27) {
          e.preventDefault();
          $(this).slideUp().attr('aria-hidden', 'true');
          $(this).parent().removeClass('active').attr('aria-expanded', 'false');
          $(this).siblings('.collection-filter-sort__button').focus();
          return;
        }

        if (e.key === 'Tab') {
          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      });
    }
  });
  return Collection;
})();
theme.ProductTabs = (function () {

  function ProductTabs(container) {
    var $container = this.$container = $(container);
    var $button = $container.find('.product-tabs__button:not(.ariaToggleSlide)');
    var $text = $container.find('.product-tabs__text');
    var $image = $container.find('.product-tabs__image');


    $button.on('click', function () {
      var index = $(this).index();

      if (!$(this).hasClass('active')) {
        $button.removeClass('active');
        $(this).addClass('active');

        $text.hide().eq(index).fadeIn();
        $image.hide().eq(index).fadeIn();
      }
    });
  }
  return ProductTabs;
})();
theme.ProductColorSwatchDetails = (function () {

  function ProductColorSwatchDetails(container) {
    var $container = this.$container = $(container);

    this.changeColorSwatchDropdown();
    this.changeImageDescription();
  }

  ProductColorSwatchDetails.prototype = $.extend({}, ProductColorSwatchDetails.prototype, {

    changeColorSwatchDropdown: function() {
      $(document).on('click', '.product-sw-dropdown__button', function () {
        var titleWidth = $(this).find('.product-sw-dropdown__group').width();

        $(this).parent().toggleClass('active');
        $(this).next().css('width', titleWidth + 'px').slideToggle();
      });

      $(document).mouseup(function (e){
        var div = $('.product-sw-dropdown .product-sw-dropdown__list');
        var parentDiv = $('.product-sw-dropdown .product-sw-dropdown__button');
        if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {

          $('.product-sw-dropdown .product-sw-dropdown__inner').removeClass('active');
          $('.product-sw-dropdown .product-sw-dropdown__list').slideUp();
        }
      });

      $(document).on('click', '.product-sw-dropdown__item', function () {
        var text = $(this).text();
        var value = $(this).attr('data-value');
        var $parent = $(this).parents('.product-sw-dropdown');
        var $value = $parent.find('.product-sw-dropdown__value');

        $parent.find('.product-sw-dropdown__inner').removeClass('active');
        $parent.find('.product-sw-dropdown__list').slideUp();
        $(this).siblings().removeClass('selected');
        $(this).addClass('selected');

        if ($('.product-sw-swatches__content[data-type-swatches="'+ value +'"]').is(":hidden")) {
          $('.product-sw-swatches__content').hide();
          $('.product-sw-swatches__content[data-type-swatches="'+ value +'"]').fadeIn();
        }

        $value.html(text);
      });
    },

    changeImageDescription: function () {
      var $image = $('.product-sw-swatches__image');

      $image.on('click mouseenter', $.debounce(100, function () {
        var index = $(this).index();

        if (!$(this).hasClass('active')) {
          $(this).addClass('active').siblings().removeClass('active');
          $(this).parent().parent().next().find('.product-sw-swatches__text-item').hide().eq(index).fadeIn();
        }
      }));
    },

  });
  return ProductColorSwatchDetails;
})();
theme.ArticleSlideshow = (function() {
  function ArticleSlideshow(container) {
    this.$container = $(container);
    var config = $.parseJSON($(container).attr('data-slick-config'));

    if (config.arrows) {
      config["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M3.979 27L18 13.5 3.979 0 0 3.831 10.045 13.5 0 23.169z" transform="translate(-1285 -338) translate(0 48) translate(408 290) translate(877) matrix(-1 0 0 1 18 0)"/></g></g></svg></button>';
      config["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27"><g fill="none" fill-rule="evenodd"><g fill="#392C22" fill-rule="nonzero"><path d="M51.979 27L66 13.5 51.979 0 48 3.831 58.045 13.5 48 23.169z" transform="translate(-1333 -338) translate(0 48) translate(408 290) translate(877)"/></g></g></svg></button>';
    }

    if (config) {
      function initSlider() {
        $('.article-slideshow:not(.slick-initialized)').slick(config);
      }
      initSlider();

      $(window).on('resize orientationchange', $.debounce(200, function () {
        initSlider();
      }));


      function customDot ($sliderDots) {
        if (!$sliderDots) {
          return
        }

        if ($sliderDots.find('li:not(.custom-dot)').length < 2) {
          $sliderDots.hide();
        }

        $sliderDots.parents('.slick-slider').slick('slickGoTo', 0);

        var activeDotsIndex = $sliderDots.find('.slick-active').index();
        var dotsLength = $sliderDots.find('li:not(.custom-dot)').length;
        var dotWidth = 100 / dotsLength;
        var dotLeft = (100 / dotsLength) * activeDotsIndex;

        if (!$sliderDots.find('.custom-dot').length) {
          $sliderDots.append('<li class="custom-dot" style="width: '+ dotWidth +'%; left:'+ dotLeft +'%"></li>');
        }
      }

      customDot($(container).find('.slick-dots'));

      $(container).on('init', $.debounce(200, function(event, slick, breakpoint) {
        $(container).slick('slickGoTo', 0);

        customDot(slick.$dots);
      }));

      $(container).on('beforeChange', $.debounce(200, function(event, slick, currentSlide, nextSlide) {
        var slickSpeed = config.autoplay == true ? config.autoplaySpeed : config.speed;

        if (slick.$dots) {
          var activeDotsIndex = slick.$dots.find('.slick-active').index();
          var $customDot = slick.$dots.find('.custom-dot');
          var dotsLength = slick.$dots.find('li:not(.custom-dot)').length;
          var dotWidth = 100 / dotsLength;

          if (currentSlide > nextSlide) {
            $customDot.animate({
              left: dotWidth * activeDotsIndex + '%',
            }, slickSpeed)

          } else {
            $customDot.animate({
              left: dotWidth * activeDotsIndex + '%',
            }, slickSpeed)
          }
        }
      }));
    }
  }

  return ArticleSlideshow;
})();

theme.PreFooter = (function() {

  function PreFooter(container) {
    this.$container = $(container);

    var $form = $(container).find('form');

    $form.on( 'submit', function( event ) {
      event.preventDefault();
      var $form = $(this);
      var klaviyoListId = $form.attr('data-list-id');
      var email = $form.find('#email').val();
      var origin = '';
      var data = {
        'g': klaviyoListId,
        '$fields': '$source,$email,$consent_method,$consent_form_id,$origin',
        '$list_fields': '',
        '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
        '$source': 'Newsletter subscription',
        '$email': email,
        '$consent_method': 'Klaviyo Form',
        '$origin': origin
      };

      $.ajax({
        method: 'POST',
        url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
        data: data
      }).done(function (response) {
        if (response.success) {
          if (response.data.is_subscribed) {
            $('#prefooter-form__first-subscription').hide();
            $('#prefooter-form__error').hide();
            $('#prefooter-form__subscription').slideDown();
          } else if (!response.data.is_subscribed) {
            $('#prefooter-form__subscription').hide();
            $('#prefooter-form__error').hide();
            $('#prefooter-form__first-subscription').slideDown();
          }
        } else {
          $('#prefooter-form__first-subscription').hide();
          $('#prefooter-form__subscription').hide();
          $form.find('#email').val('');
          $('#prefooter-form__error').slideDown();
        }
      }).fail(function (err) {
        $('#prefooter-form__first-subscription').hide();
        $('#prefooter-form__subscription').hide();
        $form.find('#email').val('');
        $('#prefooter-form__error').slideDown();
      });
    });
  }

  return PreFooter;
})();

theme.InstagramFeed = (function() {
  function InstagramFeed(container) {
    var _self = this;
    var $container = this.$container = $(container);
    var id = this.id =  $container.attr('data-section-id');

    this.mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 1) {
          _self.filterElements();
        }
      });
    });

    this.loadInstagram();
  }

  InstagramFeed.prototype =  $.extend({}, InstagramFeed.prototype, {

    loadInstagram: function() {
      this.mutationObserver.observe(document.querySelector('.instagram-slideshow-loaded'), {
        childList: true
      });
    },

    filterElements: function () {
      var loadedInstagramContainer = this.$container.find('.instagram-slideshow-loaded');
      var slideshow = this.$container.find('.instagram-slideshow');

      loadedInstagramContainer.find('>a').detach().prependTo(slideshow);

      if (slideshow.find('>a').length > 1) {
        this.$container.animate({
          opacity: 1
        }, 500);
        this.mutationObserver.disconnect();
        this.initSlideshow();
      } else {
        this.$container.parents('.instagram').addClass('instagram--disconnect');
        this.$container.parents('.about-instagram').addClass('instagram--disconnect');
        this.$container.hide();
      }
    },

    initSlideshow() {
      var $container = this.$container.find('.instagram-slideshow');
      var config = $.parseJSON($container.attr('data-slick-config'));

      if (config.arrows) {
        config["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 12 18" fill="none"><path d="M10.2422 1L1.99976 9L10.2422 17" stroke="#392C22" style="stroke-width: 4px;"/></svg></button>';
        config["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 12 18" fill="none"><path d="M1.42383 1L9.66625 9L1.42383 17" stroke="#392C22" style="stroke-width: 4px;"/></svg></button>';
      }

      if (config) {
        $container.slick(config);

        function customDot ($sliderDots) {
          if (!$sliderDots) {
            return
          }

          if ($sliderDots.find('li:not(.custom-dot)').length < 2) {
            $sliderDots.hide();
          }

          $sliderDots.parents('.slick-slider').slick('slickGoTo', 0);

          var activeDotsIndex = $sliderDots.find('.slick-active').index();
          var dotsLength = $sliderDots.find('li:not(.custom-dot)').length;
          var dotWidth = 100 / dotsLength;
          var dotLeft = (100 / dotsLength) * activeDotsIndex;

          if (!$sliderDots.find('.custom-dot').length ) {
            $sliderDots.append('<li class="custom-dot" style="width: '+ dotWidth +'%; left:'+ dotLeft +'%"></li>');
          }
        }

        customDot($container.find('.slick-dots'));

        $container.on('breakpoint', $.debounce(200, function(event, slick, breakpoint) {
          $container.slick('slickGoTo', 0);

          customDot(slick.$dots);
        }));

        $container.on('beforeChange', $.debounce(200, function(event, slick, currentSlide, nextSlide) {
          var slickSpeed = config.autoplay == true ? config.autoplaySpeed : (config.speed / 2);

          if (slick.$dots) {
            var activeDotsIndex = slick.$dots.find('.slick-active').index();
            var $customDot = slick.$dots.find('.custom-dot');
            var dotsLength = slick.$dots.find('li:not(.custom-dot)').length;
            var dotWidth = 100 / dotsLength;

            if (currentSlide > nextSlide) {
              $customDot.animate({
                left: dotWidth * activeDotsIndex + '%',
              }, slickSpeed)

            } else {
              $customDot.animate({
                left: dotWidth * activeDotsIndex + '%',
              }, slickSpeed)
            }
          }
        }));
      }
    },
  });
  return InstagramFeed;
})();

theme.FilteredProducts = (function () {

  function FilteredProducts(container) {
    var $container = this.$container = $(container);


    this.filtered();
  }

  FilteredProducts.prototype = $.extend({}, FilteredProducts.prototype, {

    filtered: function () {
      var _self = this;
      var $button = this.$container.find('.filtered-products__filter-button');
      var $product = this.$container.find('.filtered-products__product');

      $button.on('click', function () {
        var value = $(this).attr('data-btn-filter-value');
        var $activeButton = _self.$container.find('.filtered-products__filter-button.btn--secondary');

        if ($(this).hasClass('btn--secondary')) {
          return
        }

        $activeButton.removeClass('btn--secondary').addClass('btn--primary');
        $(this).addClass('btn--secondary');

        $product.hide();
        $('[data-product-filter-value="'+ value +'"]').fadeIn();
      });
    },

  });
  return FilteredProducts;
})();
theme.BgWt = (function () {

  function BgWt(container) {
    var $container = this.$container = $(container);

    this.changeUrl()
  }


  BgWt.prototype = $.extend({}, BgWt.prototype, {

    changeUrl: function (event, slick, currentSlide, nextSlide) {
      var $slideShow = this.$container.find('[data-section-type="slideshow"]');
      var $link = this.$container.find('.bg-wt__content-wrapper');
      var blockUrlsTrue = this.$container.find('[data-block-urls-true]').attr('data-block-urls-true');

      if (!blockUrlsTrue) {return false};

      $slideShow.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var $blockHref = $slideShow.find('.slick-slide').eq(nextSlide).find('a.bg-wt__slide');
        var currentHref = 'javascript:void(0)';

        if ($blockHref.length) {
          currentHref = $blockHref.attr('href');
        }
        
        if ($link) {
          $link.attr('href', currentHref);
        }
      });
    },
  });
  return BgWt;
})();
theme.CareersForm = (function() {
	
	const selector = {
		workContainer: '[data-work-container]',
		addWorkBlockBtn: '[data-work-add]',
		workBlock: '[data-work-block]',
		workBlockCount: '[data-work-count]'
	}
	
	function CareersForm(container) {
		this.$container = $(container);
		
		var $form = $(container).find('form');
		
		$form.on( 'submit', function( event ) {
			event.preventDefault();
			
			var $form = $(this);
			var klaviyoListId = $form.attr('data-list-id');
			var name = $form.find('#name').val();
			var address = $form.find('#address').val();
			var email = $form.find('#email').val();
			var phone = $form.find('#phone').val();
			var school_name = $form.find('#school_name').val();
			var school_address = $form.find('#school_address').val();
			var degree = $form.find('#degree').val();
			var employer_name_1 = $form.find('#employer_name_1').val();
			var employer_address_1 = $form.find('#employer_address_1').val();
			var employment_date_1 = $form.find('#employment_date_1').val();
			var job_title_1 = $form.find('#job_title_1').val();
			var job_descr_1 = $form.find('#job_descr_1').val();
			var work_contact_1 = $form.find('#work_contact_1').val();
			var employer_name_2 = $form.find('#employer_name_2').val();
			var employer_address_2 = $form.find('#employer_address_2').val();
			var employment_date_2 = $form.find('#employment_date_2').val();
			var job_title_2 = $form.find('#job_title_2').val();
			var job_descr_2 = $form.find('#job_descr_2').val();
			var work_contact_2 = $form.find('#work_contact_2').val();
			var employer_name_3 = $form.find('#employer_name_3').val();
			var employer_address_3 = $form.find('#employer_address_3').val();
			var employment_date_3 = $form.find('#employment_date_3').val();
			var job_title_3 = $form.find('#job_title_3').val();
			var job_descr_3 = $form.find('#job_descr_3').val();
			var work_contact_3 = $form.find('#work_contact_3').val();
			var employer_name_4 = $form.find('#employer_name_4').val();
			var employer_address_4 = $form.find('#employer_address_4').val();
			var employment_date_4 = $form.find('#employment_date_4').val();
			var job_title_4 = $form.find('#job_title_4').val();
			var job_descr_4 = $form.find('#job_descr_4').val();
			var work_contact_4 = $form.find('#work_contact_4').val();
			var origin = '';
			var data = {
				'g': klaviyoListId,
				'$fields': '$source,$name,$address,$email,$phone,$school_name,$school_address,$degree,$employer_name_1,$employer_address_1,$employment_date_1,$job_title_1,$job_descr_1,$work_contact_1,$employer_name_2,$employer_address_2,$employment_date_2,$job_title_2,$job_descr_2,$work_contact_2,$employer_name_3,$employer_address_3,$employment_date_3,$job_title_3,$job_descr_3,$work_contact_3,$employer_name_4,$employer_address_4,$employment_date_4,$job_title_4,$job_descr_4,$work_contact_4,$consent_method,$origin',
				'$list_fields': '',
				'$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
				'$source': 'Careers application',
				'$name': name,
				'$address': address,
				'$email': email,
				'$phone': phone,
				'$school_name': school_name,
				'$school_address': school_address,
				'$degree': degree,
				'$employer_name_1': employer_name_1,
				'$employer_address_1': employer_address_1,
				'$employment_date_1': employment_date_1,
				'$job_title_1': job_title_1,
				'$job_descr_1': job_descr_1,
				'$work_contact_1': work_contact_1,
				'$employer_name_2': employer_name_2,
				'$employer_address_2': employer_address_2,
				'$employment_date_2': employment_date_2,
				'$job_title_2': job_title_2,
				'$job_descr_2': job_descr_2,
				'$work_contact_2': work_contact_2,
				'$employer_name_3': employer_name_3,
				'$employer_address_3': employer_address_3,
				'$employment_date_3': employment_date_3,
				'$job_title_3': job_title_3,
				'$job_descr_3': job_descr_3,
				'$work_contact_3': work_contact_3,
				'$employer_name_4': employer_name_4,
				'$employer_address_4': employer_address_4,
				'$employment_date_4': employment_date_4,
				'$job_title_4': job_title_4,
				'$job_descr_4': job_descr_4,
				'$work_contact_4': work_contact_4,
				'$consent_method': 'Klaviyo Form',
				'$origin': origin
			};
			
			console.log(data);
			
			// $.ajax({
			// 	method: 'POST',
			// 	url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
			// 	data: data
			// }).done(function (response) {
			// 	if (response.success) {
			// 		if (response.data.is_subscribed) {
			// 			$('#contest-form__first-subscription').hide();
			// 			$('#contest-form__error').hide();
			// 			$('#contest-form__subscription').slideDown();
			// 		} else if (!response.data.is_subscribed) {
			// 			$('#contest-form__subscription').hide();
			// 			$('#contest-form__error').hide();
			// 			$('#contest-form__first-subscription').slideDown();
			// 		}
			// 	} else {
			// 		$('#contest-form__first-subscription').hide();
			// 		$('#contest-form__subscription').hide();
			// 		$('#contest-form__error').slideDown();
			// 	}
			// }).fail(function (err) {
			// 	$('#contest-form__first-subscription').hide();
			// 	$('#contest-form__subscription').hide();
			// 	$('#contest-form__error').slideDown();
			// });
		});
		
		$form.each((index, item) => {
			$(item).slideUp();
			$(item).find(selector.workBlock).not(':first').addClass('visually-hidden');
			$(item).find(selector.addWorkBlockBtn).attr('data-blocks-count', 1);
		});
		
		$(document).on('click', selector.addWorkBlockBtn, (e) => {
			e.preventDefault();
			
			//show new work block
			$(e.target)
					.parents(selector.workContainer)
					.find(`${selector.workBlock}.visually-hidden`)
					.first()
					.removeClass('visually-hidden');
			
			//update the add button count values
			const blocksCount = $(e.target)
					.parents(selector.workContainer)
					.find(`${selector.workBlock}.visually-hidden`).length;
			$(e.target).children(selector.workBlockCount).text(4 - blocksCount);
			
			//disable add btn
			if(blocksCount <= 0) {
				$(e.target).css({
					'pointer-events': 'none',
					'opacity': '.3'
				});
			}
		});
	}
	
	return CareersForm;
})();
theme.RentPartyForm = (function() {

  function RentPartyForm(container) {
    this.$container = $(container);

    var $form = $(container).find('form');

    $form.on( 'submit', function( event ) {
      event.preventDefault();

      var $form = $(this),
         klaviyoListId = $form.attr('data-list-id'),
         email = $form.find('#contest-form-email').val(),
         emailOpIn = $form.find('#contest-form-email-opt-in').val(),
         name = $form.find('#contest-form-name').val(),
         age = $form.find('#contest-form-age').val(),
         permanentAddress = $form.find('#contest-form--permanent-address').val(),
         leaseholder = $form.find('#contest-form--leaseholder').val(),
         employed = $form.find('#contest-form--employed').val(),
         pay_rent = $form.find('#contest-form--pay_rent').val(),
         monthly_rent = $form.find('#contest-form--monthly_rent').val(),
         back_rent = $form.find('#contest-form--back_rent').val(),
         phone = $form.find('#contest-form--phone').val(),
         homePhone = $form.find('#contest-form--home-phone').val(),
         phoneOpIin = $form.find('#contest-form-phone-opt-in').val(),
         origin = '',
         data = {
        'g': klaviyoListId,
        '$fields': '$source,$email,$email_opt_in,$name,$age,$permanentAddress,$leaseholder,$employed,$pay_rent,$monthly_rent,$back_rent,$phone,$homePhone,$phoneOpIin,$consent_method,$consent_form_id,$origin',
        '$list_fields': '',
        '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
        '$source': 'Contest subscription',
        '$email': email,
        '$email_opt_in': emailOpIn,
        '$name': name,
        '$age': age,
        '$permanentAddress': permanentAddress,
        '$leaseholder': leaseholder,
        '$employed': employed,
        '$pay_rent': pay_rent,
        '$monthly_rent': monthly_rent,
        '$back_rent': back_rent,
        '$phone': phone,
        '$homePhone': homePhone,
        '$phoneOpIin': phoneOpIin,
        '$consent_method': 'Klaviyo Form',
        '$origin': origin
      };

      $.ajax({
        method: 'POST',
        url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
        data: data
      }).done(function (response) {
        if (response.success) {
          if (response.data.is_subscribed) {
            $('#contest-form__subscription').hide();
            $('#contest-form__error').hide();
            $('#contest-form__first-subscription').slideDown();
          } else if (!response.data.is_subscribed) {
            $('#contest-form__first-subscription').hide();
            $('#contest-form__error').hide();
            $('#contest-form__subscription').slideDown();
          }
        } else {
          $('#contest-form__first-subscription').hide();
          $('#contest-form__subscription').hide();
          $('#contest-form__error').slideDown();
        }
      }).fail(function (err) {
        $('#contest-form__first-subscription').hide();
        $('#contest-form__subscription').hide();
        $('#contest-form__error').slideDown();
      });
    });
  }

  return RentPartyForm;
})();

theme.ProductBudgeCount = (function() {
  const selectors = {
    yearValue: 'data-year',
    monthValue: 'data-month',
    dayValue: 'data-day',
    hourValue: 'data-hour',
    minutesValue: 'data-minutes',
    countContainer: 'data-count',
    endText: '[data-end-text]',
    endChangeToNext: 'data-change-to-next',
    productLinkDisabled: 'data-product-link-disabled',
    productURL: 'data-product-url',
    parentItem: '.product-item',
    budgeItem: '.product-badge-count',
  }

  function ProductBudgeCount(container) {
    const $container = this.$container = $(container);
    const productId = this.productId = this.$container.attr('data-product-id');
    const _self = this;

    if (this.$container.hasClass('activated')) {
      return false;
    }

    this.triggerCountOff();
    this.init();
  }

  ProductBudgeCount.prototype = $.extend({}, ProductBudgeCount.prototype, {
    init: function() {
      const _self = this;
      const $countdownClock = this.$container.find(`${selectors.budgeItem}`);

      this.$container.addClass('activated');

      if ($countdownClock.length) {
        _self.budgeCount($countdownClock.first());
      }
    },

    checkActiveItemDisableLink: function (item, defaultUrl = false) {
      const $item = $(item);
      const productLinkDisabled = $item.attr(selectors.productLinkDisabled) === 'true';
      const productURL = $item.attr(selectors.productURL);
      const productLinks = $item.parents(selectors.parentItem).find('a');

      if (!productLinkDisabled || defaultUrl) {
        productLinks.attr('href', productURL);
      } else {
        productLinks.attr('href', 'javascript:void(0)');
      }
    },

    budgeCount: function (parentItem) {
      const _self = this;
      const countdownClock = parentItem.find(`[${selectors.countContainer}]`);

      _self.checkActiveItemDisableLink(parentItem);

      if (countdownClock.length) {
        const endDateYear = parseInt(parentItem.attr(selectors.yearValue), 10);
        const endDateMonth = parseInt(parentItem.attr(selectors.monthValue), 10);
        const endDateDay = parseInt(parentItem.attr(selectors.dayValue), 10);
        const endDateHour = parseInt(parentItem.attr(selectors.hourValue), 10);
        const endChangeToNext = parentItem.attr(selectors.endChangeToNext) === 'true';
        const endDateMinutes = (parseInt(parentItem.attr(selectors.minutesValue), 10) * 60000)
        const endText = parentItem.find(selectors.endText);
        const countDownDate = new Date(Date.UTC(endDateYear, endDateMonth, endDateDay) + (3600000 * (8 + endDateHour)) + endDateMinutes).getTime();

        if (isNaN(countDownDate)) {
          parentItem.fadeIn();
          return false;
        }

        // Update the count down every 1 second
        const x = setInterval(function () {
          // Get todays date and time
          const now = new Date().getTime();
          // Find the distance between now and the count down date
          const distance = countDownDate - now;
          // Time calculations for days, hours, minutes and seconds
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let daysLabel = '';
          daysLabel = days < 10 ? "0" + days : days;
          daysLabel = "<span class='count-value'>" + daysLabel + "</span>";
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let hoursLabel = '';
          hoursLabel = hours < 10 ? "0" + hours : hours;
          hoursLabel = "<span class='count-value'>" + hoursLabel + "</span>";
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let minutesLabel = '';
          minutesLabel = minutes < 10 ? "0" + minutes : minutes;
          minutesLabel = "<span class='count-value'>" + minutesLabel + "</span>";
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          let secondsLabel = seconds < 10 ? '0' + seconds : seconds;
          secondsLabel = "<span class='count-value'>" + secondsLabel + "</span>";
          const dayString = days ? "<span class='count-value'>"+daysLabel+"<span class='count-value__type'>d:</span></span>" : '';
          const hoursString = "<span class='count-value'>"+hoursLabel+"<span class='count-value__type'>h:</span></span>";
          const minutesString = "<span class='count-value'>"+minutesLabel+"<span class='count-value__type'>m:</span></span>";
          const secondsString = "<span class='count-value'>"+secondsLabel+"<span class='count-value__type'>s</span></span>";

          const string = `${dayString}${hoursString}${minutesString}${secondsString}&nbsp;`

          countdownClock.html(string);
          parentItem.fadeIn();

          // If the count down is finished, clean the interval and text
          if (distance < 0) {
            clearInterval(x);

            if (endChangeToNext) {
              parentItem.hide();
              _self.$container.trigger('countChange', parentItem);
            } else if (endText.length) {
              countdownClock.parent().hide();
              endText.fadeIn();
            } else {
              countdownClock.hide();
            }
          }
        }, 1000);
      }

      return true;
    },

    triggerCountOff: function () {
      const _self = this;
      this.$container.on('countChange', function (evt, currentCountItem) {
        const $currentCountItem = $(currentCountItem);
        const $nextCountItem = $currentCountItem.next();

        if ($nextCountItem.length) {
          _self.budgeCount($nextCountItem);
        } else {
          _self.checkActiveItemDisableLink(currentCountItem, true);
          _self.$container.hide();
        }
      });
    }
  });

  return ProductBudgeCount;
})();


theme.CollectionNotifyMeBanner = (function() {
  function CollectionNotifyMeBanner(container) {
    const $container = this.$container = $(container);

    this.init();
  }

  CollectionNotifyMeBanner.prototype = $.extend({}, CollectionNotifyMeBanner.prototype, {
    init: function() {
      var _self = this;

      this.$container.find('button').on('click', function (evt) {
        evt.preventDefault();
        var listID = _self.$container.attr('data-klaviyo-list-id');

        function validateEmail(email) {
          var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }

        var email = _self.$container.find('[name="email"]').val();
        var phone_number = _self.$container.find('[name="phone_number"]').val();
        var origin = '';
        var data = {
          'g': listID,
          '$fields': '$source,$email,$consent_method,$timezone_offset,$phone_number',
          '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
          '$source': 'Collection product subscription',
          '$email': email,
          '$phone_number': phone_number
        };

        var $emailInvalid = _self.$container.find('.collection-notify-me-banner__email-invalid');
        var $klaviyoError = _self.$container.find('.collection-notify-me-banner__klaviyo-error');
        var $subscription = _self.$container.find('.collection-notify-me-banner__subscription');

        $emailInvalid.slideUp();
        $klaviyoError.slideUp();
        $subscription.slideUp();

        if (!validateEmail(email)) {
          $emailInvalid.slideDown();
          return
        }

        $.ajax({
          method: 'POST',
          url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
          data: data
        }).done(function (response) {
          if (response.success) {
            $subscription.slideDown();
          } else {
            console.error('Error Klaviyo: ', response.errors);
            $klaviyoError.slideDown();
          }
        }).fail(function (err) {
          $klaviyoError.slideDown();
        });
      });
    },

  });

  return CollectionNotifyMeBanner;
})();


theme.ProductVariant = (function() {

  var selectors = {
    originalSelectorId: '[data-product-input]',
  }

  function ProductVariant(container) {
    var $container = this.$container = $(container);
    this.currentVariantTitle = $container.attr('data-current-variant-title');

    this.clickAddToCart();
    this.klaviyoBIS();
    this.quizGACompleteEvent();
  }

  ProductVariant.prototype = $.extend({}, ProductVariant.prototype, theme.Cart.prototype, {

    clickAddToCart: function () {
      var _self = this;

      theme.quantitySelectors();

      $(document).on('click', '[data-add-to-cart]:not(.product-klaviyo-bis-trigger)', function (evt) {
        evt.preventDefault();
        var form = $(this).closest('form');
        var form_array = form.serializeArray();

        if (form.find('[type="file"]').length) {
          return;
        }

        $(this).prop('disabled', true);

        var form_data = {};

        $.map(form_array, function (val) {
          form_data[val.name] = val.value;
        });

        if (form_data.properties) {
          form_data.properties['_quiz_kit_id'] = '4590';
        } else {
          form_data.properties = {'_quiz_kit_id': '4590'}
        }

        if ($(this).attr('data-varaint-preorder-value') == 'true' && $('.product-preorder-item--' + form_data.id).length) {
          if (form_data.properties) {
            form_data.properties['Preorder'] = $('.product-preorder-item--' + form_data.id).find('span').text();
          } else {
            form_data.properties = {'Preorder': $('.product-preorder-item--' + form_data.id).find('span').text()};
          }
        }

        _self.ajaxAddToCart(form_data);
      })
    },

    ajaxAddToCart: function (data) {
      var _self = this;
      var $container = $(this.container);
      var errorContainer = $container.find('.product-form-error');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
      }).done(function () {
        $(document).trigger('product:added');

        $('[data-add-to-cart]').prop('disabled', false);
        if (errorContainer.length) {
          errorContainer.slideUp();
        }

        if (typeof gtag !== 'undefined') {
          gtag('event', `Product Add to Cart`, {
            event_label: `${_self.currentVariantTitle}`,
            event_category: 'Shade Finder',
          });
        }

        var _learnq = window._learnq || [];
        _learnq.push(['track', 'Added to Cart', _self.productKlaviyoObject]);

      }).fail(function (error) {
        if (error.status === 422 && errorContainer.length) {
          errorContainer.text(error.responseJSON.description);
          errorContainer.slideDown();
        }
        $('[data-add-to-cart]').prop('disabled', false);
      })
    },

    klaviyoBIS: function () {
      $(document).on('click', '.product-klaviyo-bis-trigger', function (evt) {
        evt.preventDefault();

        $(this).parents('form').find('.product-form-klaviyo-bis').slideToggle();
      });

      $('.product-form-klaviyo-bis').find('button').on('click', function (evt) {
        evt.preventDefault();

        function validateEmail(email) {
          var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }

        var $bisContainer = $(this).parents('.product-form-klaviyo-bis');
        var productId = $bisContainer.attr('data-bis-product-id');
        var variantId = $(selectors.originalSelectorId)[0].value;
        var email = $bisContainer.find('[name="email"]').val();
        var origin = '';
        var data = {
          'a': 'Jsnu2D',
          'email': email,
          '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
          'variant': variantId,
          'product': productId,
          'platform': 'shopify'
        };

        var $emailInvalid = $bisContainer.find('.product-form-klaviyo-bis__email-invalid');
        var $klaviyoError = $bisContainer.find('.product-form-klaviyo-bis__klaviyo-error');
        var $subscription = $bisContainer.find('.product-form-klaviyo-bis__subscription');

        $emailInvalid.slideUp();
        $klaviyoError.slideUp();
        $subscription.slideUp();

        if (!validateEmail(email)) {
          $emailInvalid.slideDown();
          return
        }

        $.ajax({
          method: 'POST',
          url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
          data: data
        }).done(function (response) {
          if (response.success) {
            $subscription.slideDown();
          } else {
            console.error('Error Klaviyo: ', response.errors);
            $klaviyoError.slideDown();
          }
        }).fail(function (err) {
          $klaviyoError.slideDown();
        });
      });
    },

    quizGACompleteEvent: function () {
      if (typeof gtag !== 'undefined') {
        gtag('event', `Quiz Completed`, {
          event_label: `Shade Match: ${currentVariantTitle}`,
          event_category: 'Shade Finder',
        });
      }
    }

  });
  return ProductVariant;
})();
theme.quickAdd = (function() {

  function quickAdd(container) {
    this.$container = $(container);
    this.productKlaviyoObject = JSON.parse($('[data-product-klaviyo-json]', this.$container.parents('.product-item--js')).html());
    const _this = this;
    const option = '.product-options-swatch__input';
    const optionSelect = '.product-options__item';
    const quickAdd = '.quick-add';
    const $slider = $('[data-slick-config]', $(container))
    
    if ($slider.length) {
      const config = $.parseJSON($slider.attr('data-slick-config'));
      config["navText"] = [$('<button type="button" class="quick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg></button>'), $('<button type="button" class="quick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg></button>')];
      
      $slider.owlCarousel(config);
    }
  
    $('.product-options__button', $(container)).off().on('click', function () {
      $(this).parent().toggleClass('active');
      $(this).next().slideToggle();
    });
    
    $(container).on('change', option, function () {
      optionChange(this)
    });
    
    $(container).on('click', optionSelect, function () {
      var value = $(this).attr('data-value');
      var $parent = $(this).parents('.product-options');
      var $spanForValue = $parent.find('.product-options__value');
  
      $parent.find('.product-options__inner').removeClass('active');
      $parent.find('.product-options__list').slideUp();
      $(this).siblings().removeClass('selected');
      $(this).addClass('selected');
  
      $spanForValue.html(value);
      optionChange(this)
    });
  
    $(document).mouseup(function (e){
      var div = $('.product-options .product-options__list');
      var parentDiv = $('.product-options .product-options__button');
      if (!div.is(e.target)
        && div.has(e.target).length === 0
        && !parentDiv.is(e.target)
        && parentDiv.has(e.target).length === 0) {
      
        $('.product-options .product-options__inner').removeClass('active');
        $('.product-options .product-options__list').slideUp();
      }
    });
    
    $(container).on('click', quickAdd, function (e) {
      e.preventDefault();
      
      const selectedVariant = $('[name="id"]', $(container).parents('.product-item--js')).val();
      const $button = $('.product-item__btn', $(container));
      const errorContainer = $('.product-form-error', $(container));
      const data = {
        id: selectedVariant,
        quantity: 1
      }
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data
      }).done(function () {
        $(document).trigger('product:added');
        $button.prop('disabled', false);
        
        if (errorContainer.length) {
          errorContainer.slideUp();
        }
    
        var _learnq = window._learnq || [];
        _learnq.push(['track', 'Added to Cart', _this.productKlaviyoObject]);
    
      }).fail(function (error) {
        if (error.status === 422 && errorContainer.length) {
          errorContainer.text(error.responseJSON.description);
          errorContainer.slideDown();
        }
        $button.prop('disabled', false);
      })
    })
  
    function optionChange (element) {
      const $variantSelector = $('[name="id"]', $(container).parents('.product-item--js'));
      const $selectedOption = $variantSelector.find(`option[data-variant-title="${$(element).attr('data-value')}"]`);
      const selectedVariant = $.parseJSON($selectedOption.attr('data-variant-json'));
      const $button = $('.product-item__btn', $(container));
      const $price = $('.product-item__price', $(container));
      const $featuredImage = $('.slide-product-item__image img:first-child, .product-item__image:not(.product-item__image--hover) img', $(element).parents('.product-item--js'));
    
      const price = selectedVariant?.variant_price;
      const compareAtPrice = selectedVariant?.variant_compare_price;
      let priceTemplate = (compareAtPrice.length > 0)
          ? `${price} <s>${compareAtPrice}</s>`
          : price;
      
      $variantSelector.val($selectedOption.attr('value'));
      $button.html(selectedVariant.button_text);
      $price.html(priceTemplate);
      $featuredImage.attr('srcset', selectedVariant.image);
      selectedVariant.enable_add_to_cart ? $button.removeClass('product-item__btn-notify').addClass('quick-add') : $button.removeClass('quick-add').addClass('product-item__btn-notify');
      
      document.dispatchEvent(new CustomEvent('YMK:VariantChange', {detail: {sku: selectedVariant.sku}}));
    }
  
    //DROPDOWN OPTIONS
    $(document).mouseup(function (e){
      var div = $('.product-options-select .product-options-select__list');
      var parentDiv = $('.product-options-select .product-options-select__button');
      if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {
      
        $('.product-options-select .product-options-select__inner').removeClass('active');
        $('.product-options-select .product-options-select__list').slideUp();
      }
    });
    
    $(document).mouseup(function (e){
      var div = $('.product-options .product-options__list');
      var parentDiv = $('.product-options .product-options__button');
      if (!div.is(e.target)
          && div.has(e.target).length === 0
          && !parentDiv.is(e.target)
          && parentDiv.has(e.target).length === 0) {
      
        $('.product-options .product-options__inner').removeClass('active');
        $('.product-options .product-options__list').slideUp();
      }
    });
  
    $('.product-options-select__item', this.$container).on('click', function () {
      var value = $(this).attr('data-value');
      var $parent = $(this).parents('.product-options-select');
      var $input = $parent.prev().find('[data-single-option-selector][value="'+ value +'"]');
      var $labelText = $parent.find('.product-options-select__label>div:first-child');
      var $content = $(this).html();
    
      $parent.find('.product-options-select__inner').removeClass('active');
      $parent.find('.product-options-select__list').slideUp();
      $(this).siblings().removeClass('selected');
      $(this).addClass('selected');
    
      $labelText.html($content);
      $input.trigger('click');
    });
  
    $('.product-options-swatch__btn', this.$container).on('click', function () {
      var $wrapper = $(this).parents('.product-options-swatch__wrapper');
      var $fieldset = $wrapper.find('.product-options-swatch-fieldset');
    
      $wrapper.toggleClass('collapse');
    
      if ($wrapper.hasClass('collapse')) {
        $(this).find('span:first-child').hide();
        $(this).find('span:nth-child(2)').fadeIn();
        $fieldset.find('h4').show().animate({width: "100%"}, 300, function () {
          $fieldset.find('h4').show()
        });
      } else {
        $(this).find('span:nth-child(2)').hide();
        $(this).find('span:first-child').fadeIn();
        $fieldset.find('h4').animate({width: "0%"}, 300, function () {
          $fieldset.find('h4').hide()
        });
      }
    });
  
    $(document).on('click', '.product-options-swatch__input[data-single-option-selector]', function () {
      $('.product-options-select__item[data-value="' + $(this).val() + '"]:not(.selected)').trigger('click');
    });
  
    $('.product-options__item', this.$container).on('click', function () {
      var value = $(this).attr('data-value');
      var $parent = $(this).parents('.product-options');
      var $input = $parent.find('[data-single-option-selector]');
      var $spanForValue = $parent.find('.product-options__value');
    
      $parent.find('.product-options__inner').removeClass('active');
      $parent.find('.product-options__list').slideUp();
      $(this).siblings().removeClass('selected');
      $(this).addClass('selected');
    
      $spanForValue.html(value);
      $input.val(value).trigger('change');
    });
    
    $('.product-options-select__button', this.$container).on('click', function () {
      $(this).parent().toggleClass('active');
      $(this).next().slideToggle();
    });
    
    $('.product-options__button', this.$container).on('click', function () {
      $(this).parent().toggleClass('active');
      $(this).next().slideToggle();
    });
  }

  return quickAdd;
})();

theme.TryItNowModule = (function() {
  const selectors = {
    resetModule: '[data-ymk-reset]',
    applyOnClick: '[data-ymk-apply]'
  };
  
  function TryItNowModule(container) {
    const $container = this.$container = $(container);
    this.sectionId = $container.attr('data-section-id');
  
    this.setInitialSku();
  
    if(!window.YMK) {
      window.ymkAsyncInit = this.tryOnInit.bind(this);
    } else {
      this.tryOnInit.call(this);
    }
    
    $container.on('click', selectors.applyOnClick, this.onApplyYMK);
    document.addEventListener('YMK:VariantChange', this.onYMKVariantChange.bind(this));
  }
  
  TryItNowModule.prototype = $.extend({}, TryItNowModule.prototype, theme.Cart.prototype, {
    tryOnInit: function() {
      window.YMK.init({
        showCloseBtnOnLauncher: true,
        enableAccessibilityMode: true
      });
      
      window.YMK.open();
      
      this.tryOnChangeWidgetSize();
  
      YMK.addEventListener('loaded', () => {
        if (!this.sku)  return;
        YMK.applyMakeupBySku(this.sku);
      });
    
      YMK.addEventListener('closed', () => {
        console.log('YMK closed');
        
        this.$container.removeClass('ymk-opened');
  
        YMK.open();
      });
    
      YMK.addEventListener('engineClosd', () => {
        if(!window.YMK) return;
        
        console.log('YMK endgineClosed');
      });
    
      YMK.addEventListener('opened', () => {
        console.log('YMK opened');
      
        setTimeout(() => {
          this.tryOnChangeWidgetSize();
        }, 3000);
      
        this.$container.addClass('ymk-opened');
      });
    
      $(window).on('resize orientationchange', $.throttle(300, () => {
        this.tryOnChangeWidgetSize();
      }));
    
      console.log('YMK: INITIALIZED');
    },
  
    onApplyYMK: function() {
      this.sku = $(this).attr('data-ymk-apply');
      
      if (YMK.isLoaded()) {
        YMK.applyMakeupBySku(this.sku);
      }
    },
  
    onYMKVariantChange: function(e) {
      this.sku = e.detail.sku;
      
      if(!window.YMK || !this.sku) return;
  
      if (YMK.isLoaded()) {
        YMK.applyMakeupBySku(this.sku);
      }
    },
  
    onDestroyYMK: function() {
      if (!window.YMK) return;
      
      window.YMK.close();
    },
  
    tryOnChangeWidgetSize: function() {
      if(!window.YMK) return;
    
      let imageContainerWidth = $('.try-now__module', this.$container).width();
      
      window.YMK.changeSize({
        width: imageContainerWidth,
        height: parseInt((480 / 360) * imageContainerWidth)
      });
    },
    
    setInitialSku: function() {
      this.sku = $(selectors.applyOnClick, this.$container).first().attr('data-ymk-apply');
    }
  });
  
  return TryItNowModule;
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('product-bundle', theme.ProductBundle);
  sections.register('product-bundle-item', theme.ProductBundleItem);
  sections.register('slideshow', theme.Slideshow);
  sections.register('ember-native-video', theme.EmbedNativeVideo);
  sections.register('customer-info', theme.AccountInfo);
  sections.register('header', theme.Header);
  sections.register('promo-bar', theme.PromoBar);
  sections.register('running-text', theme.RunningText);
  sections.register('video-and-products', theme.VideoProducts);
  sections.register('video-and-products-block', theme.VideoProductsBlock);
  sections.register('blog', theme.Blog);
  sections.register('collection-template', theme.Collection);
  sections.register('product-tabs', theme.ProductTabs);
  sections.register('article-slideshow', theme.ArticleSlideshow);
  sections.register('product-color-swatch-details', theme.ProductColorSwatchDetails);
  sections.register('prefooter', theme.PreFooter);
  sections.register('instagram-feed', theme.InstagramFeed);
  sections.register('filtered-products', theme.FilteredProducts);
  sections.register('background-image-with-text', theme.BgWt);
  sections.register('gwp-modal-product', theme.GwpModalProduct);
  sections.register('careers-form', theme.CareersForm);
  sections.register('rent-party-form', theme.RentPartyForm);
  sections.register('product-budge-count', theme.ProductBudgeCount);
  sections.register('collection-notify-me-banner', theme.CollectionNotifyMeBanner);
  sections.register('product-variant', theme.ProductVariant);
  sections.register('quick-add', theme.quickAdd);
  sections.register('try-it-now-module', theme.TryItNowModule);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
if(window.location.pathname == "/") {
  renderPwrSnippets();
}
  function renderPwrSnippets () {
    if ($('body').attr('data-pr-review') === 'false') {
      return false;
    }

    window.pwr = window.pwr || function () {
      (pwr.q = pwr.q || []).push(arguments);
    };

    var defaultOptions = {
      api_key: "aa0e3522-a085-4aaf-adf5-84ece73acb38",
      locale: "en_US",
      merchant_group_id: "1853095029",
      merchant_id: "1377803268"
    }
    var products = [];

    $('[id^="category-snippet"]').each(function( i, elem ) {
      var $elem = $(elem);
      var productId = $elem.attr('data-product-id');
      var id = $elem.attr('id');

      var options = $.extend({}, defaultOptions);
      options['page_id'] = productId;
      options.components = {CategorySnippet: id};

      products.push(options);
    });

    if (products.length && 'pwr' in window) {
      pwr('render', products);
    }
  }

});

$(document).on('blur', 'input, textarea', function  () {
  var isApple = ['iPhone', 'iPad', 'iPod', 'iPad Simulator', 'iPhone Simulator', 'iPod Simulator',].includes(navigator.platform);

  if ($('html').hasClass('global_sidebar--open') && isApple) {
    setTimeout(function () {
      $('html,body').animate({
        scrollTop: 0
      }, 0);
    }, 0);
  }
})

$(window).on('load', function() {
  var showAnimations = $('body').data('animations');
  if ($('.preloader').length) {
    $('.preloader').fadeOut('100');
  }
  if (showAnimations && window.AOS) {
    AOS.init({once: true});
    $('body').addClass('aos-initialized');
  }
});